function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#1A87C7;}\n\t.st1{fill:#66CEEF;}\n\t.st2{fill:#BDEDF8;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M539.48,560.2c-3.6-2-4.8-6.6-2.8-10.2s6.6-4.8,10.2-2.8l5.8,3.4c6.2-13.8,9.6-28,9.6-40.8 c0-18.2-6.4-31.8-18.2-38.6c-9-5-19.8-5.6-31.4-1.6v11.6c0,4.2-3.4,7.4-7.4,7.4s-7.4-3.2-7.4-7.4v-4c-13,8.4-25,21.4-34.2,37.2 c-10,17.4-15.6,36-15.6,52.6c0,12.6,3.2,22.8,9.2,30.4l2.6-4.6c2-3.6,6.6-4.8,10.2-2.8c3.6,2,4.8,6.6,2.8,10.2l-3.8,6.4 c4.4,2,9,3.2,14,3.2c8.2,0,17-2.6,26-7.8c14-8,27-21.8,37-38.4L539.48,560.2z M501.49,589.8c-11,6.4-20.8,7.6-27.8,3.6 s-10.8-13.2-10.8-25.8c0-14,4.8-30,13.6-45.2c8.8-15.2,20.2-27.4,32.4-34.4c6.6-3.8,13-5.8,18.4-5.8c3.4,0,6.6,0.8,9.2,2.4 c7,4,10.8,13.2,10.8,25.8c0,14-4.8,30.2-13.6,45.2C525.29,570.4,513.89,582.6,501.49,589.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M545.89,564l38.6,22.4c1.2,0.6,2.4,1,3.8,1c2.6,0,5-1.4,6.4-3.8c2-3.6,0.8-8.2-2.8-10.2l-39.2-22.6 c-1.8,4-3.8,8-6,11.8C546.68,563,546.29,563.6,545.89,564z"
}), React.createElement("path", {
  className: "st0",
  d: "M536.68,550.2c-2,3.6-0.8,8,2.8,10.2l6.4,3.8c0.2-0.4,0.6-0.8,0.8-1.4c2.2-3.8,4.2-7.8,6-11.8l-5.8-3.4 C543.29,545.4,538.89,546.6,536.68,550.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M457.49,597.6l-41.4,71.8c-2,3.6-0.8,8,2.8,10.2c1.2,0.6,2.4,1,3.8,1c2.6,0,5-1.4,6.4-3.8l40.2-69.8 c-0.8-0.4-1.8-0.6-2.6-1.2C462.69,603.8,460.09,601.2,457.49,597.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M470.09,590.4c-3.6-2-8-0.8-10.2,2.8l-2.6,4.6c2.6,3.2,5.4,6.2,9,8.2c0.8,0.4,1.8,0.6,2.6,1.2l3.8-6.4 C475.09,597.2,473.89,592.6,470.09,590.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M518.69,238.6c0.8-0.2,1.8-0.4,2.6-0.8c2.2-0.6,4.2-1.4,6.6-1.8c1.8-0.4,3.4-0.6,5.2-1c2.2-0.4,4.4-1,6.8-1.2 c-3.6-2-7.2-4-10.6-5.6C525.48,231.8,522.09,235.4,518.69,238.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M462.69,264.8c-8,0-15.4-1.8-22-5.8l-16-9.2c-50.2,40.4-87.2,107.4-93.6,172.2l37.2,21.4 c0.2-1.8,0.8-3.4,1-5.2c1-6.2,2-12.6,3.6-19c0.8-3.8,1.8-7.4,3-11.2c1.4-4.8,2.8-9.4,4.4-14.2c2.2-6.4,4.6-12.6,7.2-18.8 c1-2.2,1.8-4.2,2.8-6.4c3.6-8.2,7.8-16.2,12.2-24c0.2-0.4,0.4-1,0.8-1.4c0.2-0.2,0.4-0.6,0.6-0.8c5.2-9,10.8-17.6,16.8-25.8 c0.8-1,1.4-2,2.2-3.2c4.8-6.2,9.8-12,15-17.8c2.4-2.8,4.8-5.6,7.2-8.2c2-2,4.2-3.8,6.4-5.8c7-6.8,14.4-13,21.8-18.6 C469.48,263.6,465.89,264.8,462.69,264.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M378.09,461.8L378.09,461.8c-1,0.6-2.2,0.8-3.4,0.8C375.69,463,376.89,462.4,378.09,461.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M554.28,234c10.2,0.8,19.8,3.6,28.4,8.6c-4.6-2.6-9.6-5.8-15-9c-9.4-5.8-19.4-11.8-29.2-17 c-1.6,2-3.2,3.8-4.8,5.8C540.68,225.6,547.69,229.8,554.28,234z"
}), React.createElement("path", {
  className: "st0",
  d: "M315.89,425.4c-0.2,2.8,1.2,5.6,3.8,7l51.2,29.6c1.2,0.8,2.4,1,3.8,1c-1.4,0-2.8-0.4-4-1.2 c-2.4-1.4-3.8-4-3.6-6.8c0-1.2,0.4-2.4,0.4-3.6l-44.2-25.6c5.2-66.8,41.6-136.6,94.6-180l-6.6-3.8 C358.29,286.2,321.29,356,315.89,425.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M539.48,234c-2.4,0.2-4.6,0.8-6.8,1.2c7.4-1.2,14.6-1.6,21.6-1c-6.8-4-13.6-8.2-20.6-11.6c-1.6,2-3.2,4-5,5.8 C532.69,229.8,535.89,231.8,539.48,234z"
}), React.createElement("path", {
  className: "st0",
  d: "M420.29,316.6c-6,8.2-11.8,16.8-16.8,25.8C408.89,333.4,414.48,324.8,420.29,316.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M375.69,408c-1,3.8-2,7.4-3,11.2C373.89,415.4,374.69,411.6,375.69,408z"
}), React.createElement("path", {
  className: "st0",
  d: "M402.49,344.8c-4.4,7.8-8.6,15.8-12.2,24C393.89,360.4,397.69,352.4,402.49,344.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M527.69,236c-2.2,0.6-4.4,1.2-6.6,1.8C523.29,237.2,525.48,236.2,527.69,236z"
}), React.createElement("path", {
  className: "st0",
  d: "M444.69,287.4c2-2.2,4.2-3.8,6.4-5.8C449.29,283.6,446.89,285.4,444.69,287.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M387.49,374.8c-2.6,6.2-5,12.4-7.2,18.8C382.49,387.4,384.69,381,387.49,374.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M368.29,443.4l-37.2-21.4c6.4-64.6,43.2-131.6,93.6-172.2l-6.8-4c-52.8,43.6-89.4,113.2-94.6,180l44.2,25.6 c0.4-4.4,1-8.8,1.8-13.4C369.29,439.8,368.69,441.6,368.29,443.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M437.69,295.6c-5.2,5.8-10.2,11.6-15,17.8C427.49,307.2,432.69,301.6,437.69,295.6z"
}), React.createElement("path", {
  className: "st2",
  d: "M420.29,176.6c3.6-14.4,9.4-29,17.6-43.2s18-26.6,28.8-36.8c2.6-2.6,5.2-5,8-7.4c0.6-0.6,1.2-1,1.8-1.6 c11.2-9.2,23.2-16,35.4-19c-12.8-7.6-26.6-15-33.2-15.8c-1.6-0.2-3.4-0.4-5-0.4c-35,0-72,44.2-87,88c-12.6,36-8.6,64.4,10.4,75.8 l21.6,12.4c-3.4-11.8-3.4-25.4-1-39.2c0.2-0.8,0.2-1.4,0.4-2.2C418.69,184.2,419.48,180.4,420.29,176.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M393.09,223c-58.8-35.6,16.8-185.8,86.4-177.2c9.6,1.2,28.8,12.4,45,22.2c8.2-0.2,16.2,1.4,23,5.2 c-3.2-1.8-7.4-4.4-12.2-7.4c-23.2-14.2-43.2-26-55-27.4c-44.6-5.4-89.8,45.2-108,97.4c-15,43.2-8.8,78,16.8,93.6l21.8,12.6 c2-1.8,4-3.4,6-5L393.09,223z"
}), React.createElement("path", {
  className: "st0",
  d: "M428.09,247.4c-1.2,0.8-2.4,1.6-3.4,2.4l16,9.2C435.69,256,431.89,251.8,428.09,247.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M424.29,241c0-0.2-0.2-0.2-0.2-0.4l-6.6-3.8c-2,1.6-4,3.4-6,5l6.6,3.8C420.09,244.2,421.89,242.8,424.29,241z"
}), React.createElement("path", {
  className: "st0",
  d: "M428.09,247.4c-1.4-2-2.8-4-4-6.2c-2,1.6-4.2,3-6.2,4.6l6.8,4C425.69,249,426.89,248,428.09,247.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M420.29,176.6c-1,3.6-1.8,7.2-2.4,10.8C418.69,184.2,419.48,180.4,420.29,176.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M466.89,96.6c2.6-2.6,5.2-5.2,8-7.4C471.89,91.6,469.48,94.2,466.89,96.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M416.29,206.8c0-5.6,0.4-11.2,1.4-17c-2.4,14-2.4,27.4,1,39.2l-21.6-12.4c-19-11.6-23-39.8-10.4-75.8 c15.2-43.6,52-88,87-88c1.6,0,3.4,0,5,0.4c6.6,0.8,20.4,8.2,33.2,15.8c-12.2,2.8-24.2,9.8-35.4,19c4.6-3.6,9.2-6.8,14-9.6 c12-6.8,23.4-10,34.2-10.2c-16.2-9.8-35.4-21-45-22.2c-69.6-8.6-145.4,141.6-86.4,177.2l24.2,14c1.2-1,2.6-1.8,3.8-2.6 C418.09,226.2,416.29,217.4,416.29,206.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M417.49,236.8l6.6,3.8c-1-2-1.8-4.2-2.8-6.4C419.89,235,418.69,236,417.49,236.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M575.48,255.4c-0.8-0.4-1.4-0.6-2.2-1c-2.6-1.4-5.4-2.4-8.2-3.4c-1.6-0.6-3.4-1-5-1.4c-4-0.8-8-1.4-12.2-1.4 c-0.2,0-0.4,0-0.6,0c-3.4,0-7,0.4-10.8,0.8c-0.4,0-0.8,0.2-1.2,0.2c-3,0.6-6.2,1.4-9.4,2.2c-1.4,0.4-2.6,0.8-4,1.2 c-1.8,0.6-3.6,1.4-5.4,2c-6,2.4-12.2,5.2-18.8,8.8c-28,17-52.6,42.4-72.2,71.8c-2.8,4.2-5.6,8.2-8.2,12.6 c-14.6,24.6-25.4,51.6-31.2,78.8c-0.2,0.6-0.2,1.4-0.4,2c-0.8,4.2-1.2,8.2-1.8,12.4l222-128.2 C603.69,286,592.89,265.4,575.48,255.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M560.29,249.8c1.6,0.4,3.4,0.8,5,1.4C563.69,250.6,561.88,250.4,560.29,249.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M522.09,253c1.4-0.4,2.6-0.8,4-1.2C524.69,252.2,523.29,252.4,522.09,253z"
}), React.createElement("path", {
  className: "st1",
  d: "M575.48,255.4c-0.6-0.4-1.4-0.4-2-0.8C574.09,254.8,574.69,255,575.48,255.4L575.48,255.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M498.09,263.6c6.6-3.6,12.8-6.4,18.8-8.8C510.69,257.4,504.48,260,498.09,263.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M498.09,263.6c-26.6,15.4-51.6,40.8-72.2,71.8C445.29,306.2,470.09,281,498.09,263.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M383.29,441.6l0.6-0.4c0.6-4.2,1-8.2,1.8-12.4C385.09,433.4,383.89,437.4,383.29,441.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M415.89,350.4c-14.4,24.8-24.4,51.2-29.6,76.4c5.8-27.2,16.6-54.2,31.2-78.8 C416.89,349,416.29,349.8,415.89,350.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M547.89,248.4c-0.2,0-0.4,0-0.4,0C547.69,248.6,547.89,248.4,547.89,248.4L547.89,248.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M535.48,249.6c0.4,0,0.8-0.2,1.2-0.2C536.49,249.2,535.89,249.6,535.48,249.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M585.48,252.4c-0.2,0.4-0.8,0.4-1,0.8c16.6,12.6,27.6,34,29.2,64l-231.2,133.4c-0.2,1.8-0.6,3.6-0.8,5.2 c-0.2,2.4-1.6,4.6-3.8,5.8l0,0l239.4-138.2c2.4-1.4,3.8-4.2,3.8-7c-2-34.8-15.8-61.2-38.6-74.2 C586.29,244.4,587.69,249,585.48,252.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M451.29,281.6c7-6.8,14.4-13,22-18.6h-0.2C465.69,268.6,458.09,274.8,451.29,281.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M518.29,238.6c1-0.4,1.8-0.6,2.8-0.8C520.29,238,519.28,238.4,518.29,238.6L518.29,238.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M373.09,419.2c-1.4,6.4-2.6,12.6-3.6,19C370.29,431.6,371.49,425.4,373.09,419.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M437.69,295.6c2.4-2.6,4.6-5.6,7.2-8.2C442.49,290,440.09,293,437.69,295.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M402.49,344.8c0.4-0.8,0.8-1.4,1.2-2.2c-0.2,0.2-0.4,0.6-0.6,0.8C402.69,343.6,402.69,344.2,402.49,344.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M422.69,313.6c-0.8,1-1.4,2-2.2,3.2C421.29,315.6,421.89,314.4,422.69,313.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M380.09,393.6c-1.6,4.8-3,9.4-4.4,14.2C377.09,403,378.69,398.4,380.09,393.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M390.09,368.6c-1,2.2-1.8,4.2-2.8,6.4C388.09,373,389.29,370.6,390.09,368.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M532.89,235c-1.8,0.4-3.4,0.4-5.2,1C529.28,235.4,531.29,235.4,532.89,235z"
}), React.createElement("path", {
  className: "st0",
  d: "M514.69,247.8C515.09,247.8,515.09,247.8,514.69,247.8C515.09,247.8,515.09,247.8,514.69,247.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M522.69,245c1.6-0.4,3-1,4.6-1.4C525.48,244.2,524.09,244.8,522.69,245z"
}), React.createElement("path", {
  className: "st0",
  d: "M427.49,319.6c4.2-5.8,9-11,13.6-16.4C436.29,308.6,431.49,314,427.49,319.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M543.08,241.2c1.8-0.2,3.6-0.2,5.2-0.2C546.68,241,544.69,241,543.08,241.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M381.89,456c0.2-1.8,0.6-3.6,0.8-5.2l-8.2,4.8l-7-4c0,1.2-0.4,2.4-0.4,3.6c-0.2,2.8,1.2,5.4,3.6,6.8 c1.2,0.8,2.6,1.2,4,1.2c1.2,0,2.4-0.4,3.6-1C380.29,460.6,381.89,458.6,381.89,456z"
}), React.createElement("path", {
  className: "st0",
  d: "M556.49,241.6c0.4,0,1,0,1.4,0.2C557.49,241.6,556.68,241.6,556.49,241.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M396.49,372.2c3.2-7,6.8-13.8,10.6-20.6C403.29,358,399.89,365,396.49,372.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M386.29,398c0.8-2.2,1.8-4.4,2.6-6.4C388.09,394,387.09,396,386.29,398z"
}), React.createElement("path", {
  className: "st0",
  d: "M409.89,346.2c5.2-8.8,10.6-17.2,16.6-25.4C420.69,329.2,415.09,337.4,409.89,346.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M531.88,242.8c2.2-0.4,4.2-0.8,6.4-1C536.49,241.8,534.09,242.4,531.88,242.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M579.09,249c2,1.2,3.6,3,5.6,4.4c0.2-0.4,0.8-0.4,1-0.8c1.8-3.6,0.6-8-2.8-10c-8.6-5-18.2-7.8-28.4-8.6 C563.29,239.2,571.68,244.8,579.09,249z"
}), React.createElement("path", {
  className: "st0",
  d: "M532.89,235c-1.8,0.4-3.6,0.6-5.2,1c-2.2,0.4-4.4,1.2-6.6,1.8c-1,0.2-1.8,0.6-2.8,0.8 c-6,5.4-12.2,10.2-18.6,14.2c0.4,0.4,0.8,0.8,1,1.2c4.8-2.4,9.4-4.6,14-6.4l0,0c2.6-1,5-1.8,7.6-2.6c1.6-0.4,3-1,4.6-1.4 c1.6-0.4,3.2-0.8,4.8-1c2.2-0.4,4.2-0.8,6.4-1c1.6-0.2,3.2-0.2,4.6-0.4c1.8-0.2,3.6-0.2,5.2-0.2c2.8,0,5.4,0.2,8,0.6 c0.4,0,1,0,1.4,0.2c7.6,1.2,14.8,3.4,21.4,7.2c-7.4-4.2-15.8-9.6-24.8-15C547.69,233.4,540.48,233.6,532.89,235z"
}), React.createElement("path", {
  className: "st0",
  d: "M386.29,398c0.8-2.2,1.8-4.4,2.6-6.4c2.4-6.6,4.8-13.2,7.8-19.6c3.2-7,6.8-13.8,10.6-20.6 c0.8-1.4,1.4-3,2.4-4.6c0.2-0.2,0.2-0.4,0.4-0.6c5-8.8,10.6-17.2,16.6-25.4c0.4-0.4,0.6-0.8,0.8-1.2c4.2-5.8,9-11,13.6-16.4 c14.2-16.4,29.8-30.4,46.6-41.2l-3.4-2c-3.8,1.4-7.2,2.2-10.8,3c-7.6,5.8-15,12-22,18.6c-2,2-4.4,3.8-6.4,5.8 c-2.6,2.6-4.8,5.4-7.2,8.2c-5.2,5.8-10.2,11.6-15,17.8c-0.8,1-1.4,2-2.2,3.2c-6,8.2-11.6,16.8-16.8,25.8c-0.4,0.8-0.8,1.4-1.2,2.2 c-4.4,7.8-8.6,15.8-12.2,24c-1,2.2-1.8,4.2-2.8,6.4c-2.6,6.2-5,12.4-7.2,18.8c-1.6,4.6-3,9.4-4.4,14.2c-1,3.8-2,7.6-3,11.2 c-1.4,6.2-2.6,12.6-3.6,19c-0.6,4.4-1.4,9-1.8,13.4l7,4C375.69,436.6,380.09,417.4,386.29,398z"
}), React.createElement("path", {
  className: "st0",
  d: "M498.09,254.2c-1.8,1-3.6,1.4-5.4,2.4l1.6,1l0,0c2.2-1.2,4.4-2.2,6.6-3.4c-0.2-0.4-0.6-0.8-1-1.2 C499.29,253,498.69,253.6,498.09,254.2L498.09,254.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M492.69,256.6c-2.8,1.4-5.6,2.6-8.4,3.6l3.4,2c2.2-1.4,4.4-3.4,6.8-4.6L492.69,256.6z"
}), React.createElement("polygon", {
  className: "st0",
  points: "492.69,256.2 492.69,256.6 494.29,257.4 494.48,257.4  "
}), React.createElement("path", {
  className: "st0",
  d: "M575.48,255.4L575.48,255.4c17.2,10,28,30.4,30.6,57.6l-222,128.2c-0.4,3.2-1,6.2-1.4,9.4l231.2-133.4 c-1.8-30-12.8-51.4-29.2-64C582.49,256,578.89,257.4,575.48,255.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M516.68,254.8c1.8-0.6,3.6-1.4,5.4-2C520.48,253.6,518.69,254.2,516.68,254.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M526.29,251.6c3.2-1,6.4-1.8,9.4-2.2C532.49,250,529.28,250.6,526.29,251.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M417.69,348c2.6-4.4,5.4-8.4,8.2-12.6C423.09,339.8,420.09,344,417.69,348z"
}), React.createElement("path", {
  className: "st0",
  d: "M385.89,429c0.2-0.6,0.2-1.4,0.4-2C386.29,427.8,385.89,428.4,385.89,429z"
}), React.createElement("path", {
  className: "st0",
  d: "M565.29,251.2c2.8,0.8,5.6,2,8.2,3.4C570.68,253.4,567.89,252.2,565.29,251.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M536.68,249.2c3.6-0.6,7.2-0.8,10.8-0.8C544.09,248.6,540.48,248.6,536.68,249.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M547.89,248.4c4.2,0,8.2,0.6,12.2,1.4C556.29,249,552.09,248.6,547.89,248.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M556.49,241.6c-2.6-0.4-5.2-0.6-8-0.6c-1.8,0-3.4,0-5.2,0.2c-1.6,0-3.2,0.2-4.6,0.4c-2.2,0.2-4.2,0.6-6.4,1 c-1.6,0.4-3.2,0.6-4.8,1s-3,0.8-4.6,1.4c-2.6,0.8-5,1.6-7.6,2.6l0,0c-4.8,1.8-9.4,4-14,6.4c0.4,1,0.8,2,1,3c0,2.6-1.2,5-3.4,6.4 l0,0c-1.2,0.8-2.6,1.2-4,1.2c-1.2,0-2.6-0.4-3.8-1l-3-1.6c-17,11.2-32.8,25.2-46.6,41.2c-4.6,5.4-9.4,10.6-13.6,16.4 c-0.4,0.4-0.6,0.8-0.8,1.2c-6,8.2-11.6,16.6-16.6,25.4c-1,1.6-1.8,3.4-2.8,5.2c-3.8,6.8-7.4,13.6-10.6,20.6 c-2.8,6.4-5.4,13-7.8,19.6c-0.8,2.2-1.8,4.4-2.6,6.4c-6.2,19-10.2,38.2-11.6,57.4l8.2-4.8c0.4-3.2,0.8-6.2,1.4-9.4l-0.6,0.4 c0.6-4.2,1.6-8.6,2.4-12.8c0.2-0.6,0.2-1.4,0.4-2c5.4-25.2,15.2-51.6,29.6-76.4c0.4-0.8,1-1.6,1.6-2.4c2.6-4.4,5.4-8.4,8.2-12.6 c20.6-31,45.6-56.4,72.2-71.8c6.4-3.6,12.6-6.4,18.8-8.8c1.8-0.8,3.6-1.4,5.4-2c1.4-0.4,2.6-0.8,4-1.2c3.2-1,6.4-1.6,9.4-2.2 c0.4,0,0.8-0.2,1.2-0.2c3.6-0.6,7.2-1,10.8-0.8c0.2,0,0.4,0,0.4,0h0.2c4.2,0,8.2,0.6,12.2,1.4c1.8,0.4,3.4,0.8,5,1.4 c2.8,0.8,5.6,2,8.2,3.4c0.6,0.4,1.4,0.4,2,0.8l0.2,0.2l0,0c3.2,1.6,6.8,0.4,9-2.2c-1.8-1.4-3.4-3.2-5.6-4.4 c-7.2-3.8-14.2-6-21.4-7.2C557.49,241.6,556.68,241.6,556.49,241.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M579.09,249c-6.6-3.8-13.8-6-21.4-7.2C564.69,243,571.88,245,579.09,249z"
}), React.createElement("path", {
  className: "st0",
  d: "M426.49,321c0.4-0.4,0.6-0.8,0.8-1.2C426.89,319.8,426.89,320.4,426.49,321z"
}), React.createElement("path", {
  className: "st0",
  d: "M409.48,346.8c-0.8,1.4-1.6,3-2.4,4.6c1-1.6,1.8-3.4,2.8-5.2C409.89,346.6,409.48,346.6,409.48,346.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M388.89,391.6c2.4-6.6,4.8-13.2,7.8-19.6C393.69,378.6,391.29,385,388.89,391.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M374.48,455.4c1.4-19,5.4-38.4,11.6-57.4C380.09,417.4,375.69,436.6,374.48,455.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M514.69,247.8c-4.6,1.8-9.4,3.8-14,6.4l0,0C505.69,251.6,510.09,249.6,514.69,247.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M527.09,243.6c1.6-0.4,3.2-0.8,4.8-1C530.48,243,528.89,243.4,527.09,243.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M515.09,247.8c2.6-1,5-1.8,7.6-2.6C520.09,246,517.69,246.6,515.09,247.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M548.29,241c2.6,0,5.2,0.2,8,0.6C553.89,241.2,551.29,241,548.29,241z"
}), React.createElement("path", {
  className: "st0",
  d: "M538.29,241.6c1.6-0.2,3.2-0.2,4.6-0.4C541.68,241.2,540.09,241.6,538.29,241.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M487.69,262.2L487.69,262.2c-16.8,10.6-32.4,24.8-46.6,41.2C455.09,287.4,470.69,273.4,487.69,262.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M487.69,262.2l3,1.6c1.2,0.8,2.4,1,3.8,1s3-0.4,4-1.2l0,0c2.2-1.4,3.4-3.8,3.4-6.4c0-1-0.4-2.2-1-3 c-2.2,1.2-4.4,2.2-6.6,3.4C491.89,259,489.89,260.6,487.69,262.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M500.69,254.2L500.69,254.2c-2.2,1-4.4,2.2-6.6,3.4C496.29,256.2,498.69,255,500.69,254.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M494.29,257.4c-2.4,1.4-4.4,3.2-6.8,4.6l0,0C489.89,260.6,491.89,259,494.29,257.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M550.48,83.4c-0.2,0.4-0.8,0.4-1,0.8c9.4,8.4,15.2,22.2,15.2,41.2c0,22.4-7.8,47.4-20.6,69.6 c-3.6,6.4-7.8,12.4-12.4,18.2c2.4,1,4.6,2.2,7,3.4c4.2-5.6,8.2-11.6,11.8-17.8c14-24.2,21.6-50.2,21.6-73.2 c0-24.6-8.6-43-24.4-52.2h-0.2c0,0,0,0,0.2,0C551.49,75.4,552.69,79.8,550.48,83.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M450.89,255c-0.2,0.4,0,1-0.2,1.4c-1.4,2.4-3.8,3.6-6.4,3.6c-1.4,0-2.6-0.4-3.8-1c6.6,3.8,14.2,5.8,22,5.8 c3.2,0,6.8-1,10.2-1.6c2.4-1.8,5-3.4,7.4-5.2l-4.8-2.8C466.29,257.4,458.09,257.4,450.89,255z"
}), React.createElement("path", {
  className: "st0",
  d: "M494.48,247.4L494.48,247.4c-0.4,0.2-0.8,0.4-1.2,0.6l1.4,0.8c0.6-0.2,1-0.6,1.6-0.8c5-2.6,10-5,15-7 c1-0.4,2.2-0.8,3.2-1.4c1.4-0.6,2.8-1,4.2-1.4c3.6-3.2,7-6.6,10.4-10.4c-2.4-1.2-4.6-2.2-6.8-3.2 C513.69,234.2,504.29,241.8,494.48,247.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M526.88,219c2.2,1,4.6,2.2,7,3.4c1.6-2,3.4-3.8,4.8-5.8c-2.4-1.2-4.6-2.2-7-3.4 C530.29,215,528.69,217.2,526.88,219z"
}), React.createElement("path", {
  className: "st0",
  d: "M511.29,241c1-0.4,2.2-1,3.2-1.4C513.08,240.4,512.09,240.6,511.29,241z"
}), React.createElement("path", {
  className: "st0",
  d: "M529.09,228c1.6-1.8,3.2-3.8,5-5.8c-2.4-1.2-4.6-2.2-7-3.4c-1.6,2-3.2,4-5,6 C524.28,226,526.68,226.8,529.09,228z"
}), React.createElement("path", {
  className: "st0",
  d: "M495.89,248c-0.6,0.2-1,0.6-1.6,0.8l0,0C495.09,248.6,495.69,248.4,495.89,248z"
}), React.createElement("path", {
  className: "st0",
  d: "M476.49,88c-0.6,0.4-1.2,1-1.8,1.6C475.29,89,475.89,88.4,476.49,88z"
}), React.createElement("path", {
  className: "st0",
  d: "M417.69,189.8c0.2-0.8,0.2-1.4,0.4-2.2C417.69,188.4,417.69,189.2,417.69,189.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M438.09,133.6c-8.2,14-13.8,28.8-17.6,43.2c4-14.8,10.2-29.6,18-43c7.8-13.4,17.6-26.2,28.4-37 C455.89,107.2,446.29,119.6,438.09,133.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M544.09,79.8c2,1.2,3.6,2.8,5.4,4.4c0.4-0.4,0.8-0.4,1-0.8c2-3.6,0.6-8-2.8-10c0,0,0,0-0.2,0 c-6.8-3.8-14.6-5.4-23-5.2C532.09,72.4,539.09,76.8,544.09,79.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M521.29,75.4c-16.8,1.2-33.8,11.4-49,26.6c7-6.8,14.4-12.8,22.2-17.4C503.89,79.2,512.89,76,521.29,75.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M524.69,75.4c2.6,0,5,0,7.4,0.4C529.89,75.4,527.09,75.4,524.69,75.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M423.89,206.8c0-9,1.6-18.4,4-27.8c-5,18.6-5.8,36.6-0.6,51.2c0.2-0.2,0.4-0.2,0.6-0.4 C425.09,223,423.89,215.6,423.89,206.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M484.69,251.8c-3.2,1.4-6.2,2.4-9.2,3.2l4.8,2.8c2.2-1.6,4.4-3.2,6.8-4.6L484.69,251.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M433.89,243.4c0.2,0.4,0.6,0.6,1,1c-0.2-0.4-0.4-0.8-0.8-1.2C434.29,243,433.89,243,433.89,243.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M440.69,259c1.2,0.8,2.4,1,3.8,1c2.4,0,5-1.2,6.4-3.6c0.2-0.4,0-0.8,0.2-1.4c-2.2-0.8-4.6-1.2-6.6-2.4l-13-7.6 c-1,0.8-2.2,1.4-3.2,2.2C431.89,251.8,435.69,256,440.69,259z"
}), React.createElement("path", {
  className: "st0",
  d: "M487.09,253.4c0.2-0.2,0.4-0.2,0.4-0.4c1-0.6,1.8-1.4,2.6-1.8c0.2,0,0.2-0.2,0.4-0.2c1.2-0.6,2.6-1.2,3.8-2 l-1.4-0.8c-2.8,1.6-5.6,2.6-8.2,3.8L487.09,253.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M423.89,240.6c0,0.2,0.2,0.2,0.2,0.4l0.2-0.2L423.89,240.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M426.89,230c0.6,1.6,1.4,3.2,2.2,4.6c-0.6-1.6-1-3.4-1.6-5C427.49,229.8,427.09,229.8,426.89,230z"
}), React.createElement("path", {
  className: "st0",
  d: "M430.69,237.8c1,1.8,1.8,3.8,3.2,5.6l0.2-0.2C433.09,241.2,431.89,239.8,430.69,237.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M431.29,245l-7-4l-0.2,0.2c1.2,2.2,2.6,4.2,4,6.2C429.29,246.6,430.29,246,431.29,245z"
}), React.createElement("path", {
  className: "st0",
  d: "M490.29,251c-1,0.6-1.8,1.4-2.6,1.8C488.69,252.4,489.48,251.6,490.29,251c1.4-0.8,2.8-1.4,4.2-2.2l0,0 c-1.2,0.6-2.6,1.2-3.8,2C490.69,251,490.69,251,490.29,251z"
}), React.createElement("path", {
  className: "st0",
  d: "M490.69,78.4c-4.8,2.8-9.4,6-14,9.6c-0.6,0.6-1.2,1-1.8,1.6c-2.8,2.2-5.4,4.8-8,7.4 c-10.8,10.8-20.6,23.6-28.4,37s-14,28.2-18,43c-1,3.6-1.8,7.4-2.4,10.8c-0.2,0.8-0.2,1.4-0.4,2.2c-0.8,5.8-1.4,11.6-1.4,17 c0,10.4,1.8,19.4,4.8,27.4c2-1.4,3.8-2.8,5.8-4.2c-5.2-14.4-4.4-32.4,0.6-51.2c3.6-14.2,9.2-28.4,16.8-41.6 c7.6-13.2,17.2-25.2,27.6-35.4c15.2-15.2,32.2-25.4,49-26.6c1.2-0.2,2.4,0,3.6,0c2.4,0,5,0,7.4,0.4c4.2,0.8,8.4,2,12,4 c-5-2.8-11.8-7.2-19.4-11.8C514.09,68,502.49,71.2,490.69,78.4z"
}), React.createElement("polygon", {
  className: "st0",
  points: "484.69,251.8 487.09,253.4 487.09,253.4  "
}), React.createElement("path", {
  className: "st0",
  d: "M435.09,244.2c-0.4-0.4-0.8-0.6-1-1c-0.8,0.6-1.8,1.2-2.6,1.8l13,7.6C440.69,250.4,437.69,247.4,435.09,244.2z "
}), React.createElement("path", {
  className: "st0",
  d: "M430.09,236.8c-0.4-0.8-0.8-1.2-1.2-2c-0.8-1.6-1.6-3-2.2-4.6c-2,1.4-4,2.6-5.8,4.2c0.8,2.2,1.6,4.4,2.8,6.4 l0.6,0.2C426.29,239.6,428.09,238.4,430.09,236.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M430.69,237.8c-0.2-0.4-0.4-0.6-0.6-0.8c-2,1.4-4,2.6-5.8,4.2l7,4c0.8-0.6,1.8-1.2,2.6-1.8 C432.69,241.6,431.89,239.6,430.69,237.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M480.29,258c-2.4,1.6-5,3.4-7.4,5.2h0.2C475.69,261.2,478.09,259.8,480.29,258L480.29,258z"
}), React.createElement("path", {
  className: "st0",
  d: "M495.89,248c4.8-2.4,9.8-4.8,15-7C506.29,243,501.29,245.4,495.89,248z"
}), React.createElement("path", {
  className: "st0",
  d: "M514.28,239.8c1.4-0.4,2.8-0.8,4-1.2c0,0,0,0,0.2-0.2C517.09,239,515.68,239.2,514.28,239.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M511.29,241c-5.2,2-10.2,4.4-15,7c-0.6,0.2-1,0.6-1.6,0.8l3.4,2c0.8,0.4,1.4,1.2,1.8,1.8 c6.4-3.8,12.6-8.8,18.6-14.2c-1.4,0.4-2.8,0.8-4,1.2C513.08,240.4,512.09,240.6,511.29,241z"
}), React.createElement("path", {
  className: "st0",
  d: "M473.09,263c3.6-0.6,7.2-1.6,10.8-3l-3.6-2.2C478.09,259.8,475.69,261.2,473.09,263z"
}), React.createElement("path", {
  className: "st0",
  d: "M487.09,253.4c0.2-0.2,0.4-0.2,0.4-0.4C487.69,253,487.49,253,487.09,253.4L487.09,253.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M480.29,258L480.29,258c2.2-1.6,4.4-3.2,6.8-4.6l0,0C484.69,254.8,482.69,256.6,480.29,258z"
}), React.createElement("path", {
  className: "st0",
  d: "M494.48,249c-1.4,0.8-2.6,1.2-4,2c-1,0.6-1.8,1.4-2.8,2c-0.2,0.2-0.4,0.2-0.4,0.4l5.4,3.2 c1.8-0.8,3.6-1.4,5.4-2.4l0,0c0.6-0.4,1.2-0.8,1.8-1.2c-0.6-0.6-1-1.4-1.8-1.8L494.48,249z"
}), React.createElement("path", {
  className: "st0",
  d: "M487.09,253.4c-2.2,1.4-4.4,3.2-6.6,4.6l3.6,2.2c2.8-1,5.6-2.2,8.4-3.6L487.09,253.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M487.09,253.4L487.09,253.4L487.09,253.4z"
}), React.createElement("polygon", {
  className: "st0",
  points: "487.09,253.4 487.09,253.4 492.69,256.6 492.69,256.2  "
}), React.createElement("path", {
  className: "st0",
  d: "M540.68,86.2L540.68,86.2c10.6,6.4,16.8,20.2,16.8,39.2c0,20.4-7,43.8-19.8,65.8c-3.8,6.8-8.2,13-12.8,18.8 c2.4,1,4.6,2,7,3c4.4-5.8,8.6-11.8,12.4-18.2c12.8-22,20.6-47,20.6-69.6c0-19-5.8-32.8-15.2-41.2 C547.49,86.6,543.89,88,540.68,86.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M432.69,189.8c0.4-2.4,1-4.8,1.6-7C433.89,184.8,433.09,187.4,432.69,189.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M478.89,105.4c1.6-1.4,3-3,4.6-4.2C481.89,102.8,480.69,104.2,478.89,105.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M528.08,82.8c0.8,0,1.6,0.2,2.4,0.2C529.48,83,528.89,83,528.08,82.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M523.08,83c-12,0.4-24.6,6.4-36.6,16c3.6-2.8,7.4-5.6,11.2-7.8C506.89,86,515.48,83.4,523.08,83z"
}), React.createElement("path", {
  className: "st0",
  d: "M431.29,206.8c0-4.6,0.4-9.2,1.2-14c-2,12-1.8,23.2,1.2,32.8c0.2,0,0.2-0.2,0.4-0.2 C432.09,219.8,431.29,214,431.29,206.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M475.69,255l-9.6-5.6c-6.6,0.6-12.4-0.4-17.6-3.4l0,0c3,2,3.8,5.6,2.6,8.8 C458.09,257.4,466.29,257.4,475.69,255z"
}), React.createElement("path", {
  className: "st0",
  d: "M490.89,241c-0.2,0-0.4,0.2-0.4,0.2c-1.8,1-3.4,1.6-5.2,2.4l7.8,4.4c0.4-0.2,0.8-0.4,1.2-0.6l0,0 c9.8-5.8,19.2-13.6,27.8-22.6c-2.6-1.2-5-2-7.4-3C507.09,229.8,499.29,236.2,490.89,241L490.89,241z"
}), React.createElement("path", {
  className: "st0",
  d: "M520.09,216c2.4,0.8,4.6,1.8,7,3c1.6-2,3.2-3.8,4.8-5.8c-2.4-1.2-4.6-2.2-7-3 C523.08,212.2,521.68,214.2,520.09,216z"
}), React.createElement("path", {
  className: "st0",
  d: "M433.89,225.4c-0.2,0-0.2,0.2-0.4,0.2c0.6,1.6,1.2,3.2,1.8,4.6C434.48,228.6,434.29,226.8,433.89,225.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M440.09,238.6c-0.8-1-1.4-2.4-2.2-3.6C438.69,236.2,439.29,237.4,440.09,238.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M514.48,221.8c2.4,0.8,5,1.8,7.4,3c1.8-1.8,3.2-4,5-6c-2.4-1.2-4.8-2-7-3C518.08,218,516.49,220,514.48,221.8z "
}), React.createElement("path", {
  className: "st0",
  d: "M524.69,75.4c-1.2,0-2.4-0.2-3.6,0c-8.2,0.8-17.4,3.8-26.8,9.4c-7.8,4.6-15.2,10.6-22.2,17.4 c-20.4,20.4-37,49.2-44.4,77c-2.4,9.4-4,18.8-4,27.8c0,8.8,1.6,16.2,3.8,22.8c2-1.4,4-2.8,6-4.2c-3-9.4-3-20.8-1.2-32.8 c0.2-1,0.2-2.2,0.4-3.2c0.4-2.4,1-4.6,1.6-7c3.2-13.8,8.6-27.8,16.4-41.6c8-13.8,17.6-25.8,28.2-35.4c1.6-1.4,3-2.8,4.6-4.2 c1-0.8,2-1.6,3.2-2.4c12-9.6,24.4-15.6,36.6-16c0.8,0,1.6-0.4,2.4-0.4s1.6,0.2,2.4,0.2s1.6,0.2,2.4,0.2c3.6,0.6,7,1.4,10,3.2l0,0 h0.2c3,1.6,6.6,0.4,8.8-2.2c-1.8-1.6-3.4-3.2-5.4-4.4c-3.8-2-7.8-3.2-12-4C529.89,75.4,527.49,75.4,524.69,75.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M484.69,251.8c2.8-1.2,5.4-2.2,8.2-3.8l-7.8-4.4c-2.8,1.4-5.8,2.8-8.6,3.6L484.69,251.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M465.69,249.6l9.6,5.6c3-0.8,6-1.8,9.2-3.2l-8-4.6C473.09,248.6,469.48,249.2,465.69,249.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M448.29,246.2C448.29,246.2,448.29,246,448.29,246.2c-0.2,0-0.2,0-0.2-0.2c-3-1.8-5.6-4.4-8-7.2 c-2,1.4-4,2.8-6,4.2c0.2,0.4,0.4,0.8,0.8,1.2c2.6,3.2,5.6,6,9.4,8.4c2,1.2,4.4,1.8,6.6,2.4C452.09,251.8,451.29,248,448.29,246.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M436.29,232.4c-0.4-0.8-0.8-1.4-1-2.2c-0.6-1.6-1.4-3-1.8-4.6c-2,1.4-4,2.8-6,4.2c0.6,1.6,1,3.6,1.6,5 c0.4,0.8,0.8,1.4,1.2,2C432.09,235.4,434.29,234,436.29,232.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M440.09,239c0,0,0-0.2-0.2-0.2c-0.8-1-1.4-2.4-2.2-3.6c-0.6-0.8-1.2-1.6-1.6-2.6c-2,1.4-4,2.8-6,4.2 c0.2,0.2,0.4,0.6,0.6,0.8c1,2,2.2,3.8,3.4,5.4C436.29,241.6,438.09,240,440.09,239z"
}), React.createElement("path", {
  className: "st0",
  d: "M521.29,75.4c1.2,0,2.4,0,3.6,0C523.69,75.4,522.49,75.4,521.29,75.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M471.89,101.8c-10.4,10.2-20,22-27.6,35.4c-7.6,13.2-13.2,27.6-16.8,41.6 C435.09,151,451.89,122.2,471.89,101.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M544.09,79.8c-3.6-2-7.6-3.4-12-4C536.29,76.6,540.29,77.8,544.09,79.8z"
}), React.createElement("polygon", {
  className: "st0",
  points: "476.89,247.4 476.89,247.4 484.69,251.8 484.69,251.8  "
}), React.createElement("path", {
  className: "st0",
  d: "M444.48,252.4c-3.6-2.4-6.8-5.2-9.4-8.4C437.69,247.4,440.69,250.4,444.48,252.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M429.29,234.8c0.4,0.8,0.8,1.4,1.2,2l0,0C430.09,236,429.48,235.4,429.29,234.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M430.09,236.8L430.09,236.8c0.2,0.4,0.4,0.6,0.6,0.8C430.69,237.4,430.29,237.2,430.09,236.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M512.89,469.8v-58.6c0-4.2-3.4-7.4-7.4-7.4s-7.4,3.4-7.4,7.4v66.2c1.2-0.8,2.4-1.8,3.6-2.6 C505.29,472.8,509.29,471,512.89,469.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M505.29,488.6c4.2,0,7.4-3.2,7.4-7.4v-11.6c-3.6,1.2-7.4,3-11.2,5.2c-1.2,0.8-2.4,1.8-3.6,2.6v4 C498.09,485.4,501.29,488.6,505.29,488.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M290.69,787.6c-8,0-15.4-2-22-5.8l-16-9.2c-50.2,40.6-87.2,107.4-93.6,172l37.2,21.4c0.2-1.6,0.6-3.4,1-5 c1-6.4,2-12.8,3.6-19.2c0.8-3.6,1.8-7.2,2.8-10.8c1.4-4.8,2.8-9.6,4.4-14.4c2.2-6.2,4.4-12.4,7-18.4c1-2.2,1.8-4.4,3-6.8 c3.6-7.8,7.4-15.4,11.6-23c0.4-0.8,0.8-1.6,1.2-2.4c0.2-0.4,0.6-0.8,0.8-1.4c5-8.4,10.2-16.6,16-24.4c1-1.4,2-2.8,3-4.2 c4.4-5.8,9.2-11.4,14-16.8c2.6-3,5.2-6.2,8-9c1.6-1.6,3.4-3,5-4.6c7.4-7.2,15-13.8,23-19.6C297.49,786.6,293.89,787.6,290.69,787.6 z"
}), React.createElement("path", {
  className: "st1",
  d: "M346.29,761.4c1-0.4,2-0.6,2.8-0.8c2-0.6,4.2-1.2,6.2-1.8c2-0.4,4-0.8,6-1c2-0.4,4-0.8,6-1 c-3.6-2-7.2-4-10.8-5.8C353.69,755,350.09,758.4,346.29,761.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M382.49,757.2c10.2,0.8,19.8,3.6,28.4,8.6c-4.6-2.6-9.6-5.8-15-9.2c-9.4-5.8-19.2-11.8-29-17 c-1.6,2-3.2,3.8-4.8,5.8C368.69,748.8,375.69,752.8,382.49,757.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M195.09,978c0-1.2,0.4-2.4,0.4-3.6l-44.2-25.6c5-66.8,41.6-136.6,94.4-180l-6.8-3.8 c-52.8,44.4-90,114.2-95.2,183.4c-0.2,2.8,1.2,5.6,3.6,7l51.2,29.6c1.2,0.6,2.4,1,3.8,1c-1.4,0-2.8-0.4-3.8-1 C196.29,983.4,195.09,980.6,195.09,978z"
}), React.createElement("path", {
  className: "st0",
  d: "M205.89,985.2L205.89,985.2c-1,0.6-2.2,0.8-3.4,0.8C203.69,986,204.69,985.6,205.89,985.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M264.69,819.6c-4.8,5.4-9.6,11-14,16.8C255.09,830.2,260.09,825,264.69,819.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M355.69,759c-2.2,0.4-4.2,1.2-6.2,1.8C351.29,760.2,353.29,759.6,355.69,759z"
}), React.createElement("path", {
  className: "st0",
  d: "M367.69,756.8c-2,0.2-4,0.8-6,1c7.2-1.2,14-1.6,20.8-1c-6.8-4-13.6-8.2-20.6-11.6c-1.6,2-3.2,4-5,5.8 C360.29,752.8,363.89,755,367.69,756.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M203.69,931.2c-1,3.6-2,7.2-2.8,10.8C201.89,938.4,202.69,934.8,203.69,931.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M247.69,840.4c-5.8,7.8-11,16-16,24.4C236.89,856.4,242.09,848,247.69,840.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M273.09,810.4c1.6-1.6,3.4-3,5-4.6C276.29,807.4,274.48,808.8,273.09,810.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M215.09,898.4c-2.6,6.2-5,12.2-7,18.4C210.09,910.4,212.69,904.2,215.09,898.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M196.29,966.4l-37.2-21.4c6.4-64.6,43.4-131.4,93.6-172l-6.8-4c-52.8,43.6-89.4,113.2-94.4,180l44.2,25.6 c0.4-4.4,1-8.8,1.6-13.2C196.89,962.8,196.49,964.8,196.29,966.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M229.89,868.6c-4.2,7.4-8.2,15-11.6,23C221.49,883.8,225.29,876.2,229.89,868.6z"
}), React.createElement("path", {
  className: "st2",
  d: "M248.69,698.8c3.6-14,9.2-28.4,17.2-42.2c8-14,17.8-26.2,28.4-36.4c3-3,6-5.8,9-8.4c0.2-0.2,0.6-0.4,0.8-0.6 c11.2-9.4,23.4-16.4,35.6-19.2c-12.8-7.6-26.6-15-33.2-15.8c-1.6-0.2-3.4-0.2-5-0.2c-35,0-72,44.2-87,87.8 c-12.6,36-8.6,64.4,10.4,76l21.6,12.4c-3.4-12-3.4-25.6-1-39.6c0-0.4,0.2-0.6,0.2-1C246.49,707.4,247.49,703,248.69,698.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M217.49,752.6l21.8,12.6c2-1.8,4-3.4,6.2-5l-24.2-14c-58.8-35.6,17-185.8,86.4-177.2 c9.6,1.2,28.8,12.4,45,22.2c8.4-0.2,16.2,1.4,23.2,5.4c-3.4-2-7.6-4.6-12.4-7.4c-23.2-14.2-43.2-26-55-27.4 c-44.4-5.4-89.8,45.2-107.8,97.4C185.69,702.2,191.89,736.8,217.49,752.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M255.89,770.2c-1.2,0.8-2.4,1.6-3.4,2.4l16,9.2C263.69,779,259.48,775.2,255.89,770.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M251.89,764.2c-0.2-0.2-0.2-0.4-0.4-0.6l-6.4-3.8c-2,1.6-4,3.4-6.2,5l6.8,3.8 C247.69,767.4,250.09,766,251.89,764.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M255.89,770.2c-1.4-2-2.8-4-4-6.2c-2,1.6-4.2,3-6.2,4.6l6.8,4C253.89,771.8,255.09,771.4,255.89,770.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M294.29,620.2c3-2.8,6-5.8,9-8.4C300.09,614.4,297.09,617.4,294.29,620.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M248.69,698.8c-1.2,4.2-2.2,8.4-2.8,12.6C246.29,707.4,247.69,703,248.69,698.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M244.29,730c0-5.6,0.4-11.6,1.4-17.4c-2.4,14-2.4,27.8,1,39.6l-21.6-12.4c-19-11.6-22.8-40-10.4-76 c15.2-43.6,52-87.8,87-87.8c1.6,0,3.4,0,5,0.2c6.6,0.8,20.4,8.2,33.2,15.8c-12.4,2.8-24.4,10-35.6,19.2c4.6-3.8,9.6-7,14.4-10 c12-6.8,23.4-10,34.2-10.2c-16.2-9.8-35.4-21-45-22.2c-69.6-8.6-145.2,141.6-86.4,177.2l24.2,14c1.2-1,2.6-1.8,3.8-2.6 C245.89,749.2,244.29,740.2,244.29,730z"
}), React.createElement("path", {
  className: "st0",
  d: "M248.89,757.4c-1.2,1-2.6,1.8-3.8,2.6l6.4,3.8C250.69,761.6,249.89,759.6,248.89,757.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M403.29,778.6c-0.6-0.2-1-0.4-1.6-0.6c-2.8-1.4-5.8-2.6-8.8-3.6c-1.6-0.6-3.4-1-5-1.4 c-3.8-0.8-7.6-1.4-11.6-1.4c-0.8,0-1.6,0-2.4,0c-2.8,0-5.6,0.2-8.4,0.8c-1,0.2-2.2,0.4-3.2,0.6c-2.2,0.4-4.6,1-6.8,1.6 c-2,0.6-4.2,1.2-6.2,1.8c-0.6,0.2-1.4,0.6-2,0.8c-6.6,2.4-13.6,5.6-21.2,9.8c-23,14-44,33.6-61.6,56.4c-0.4,0.6-0.8,1-1.2,1.4 c-3.2,4.2-6,8.8-9,13.2c-3,4.4-6,8.6-8.6,13.2c-14.6,24.6-25.4,51.6-31.2,78.8c-0.2,0.6-0.2,1.4-0.4,2c-0.8,4.2-1.2,8.2-1.8,12.4 l222.2-128.2C431.49,808.8,420.69,788.6,403.29,778.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M211.29,965l0.8-0.4c0.6-4.2,1-8.2,1.8-12.4C213.09,956.4,211.89,960.6,211.29,965z"
}), React.createElement("path", {
  className: "st1",
  d: "M243.89,873.8c-14.4,24.8-24.4,51.2-29.6,76.4c5.8-27.2,16.6-54.2,31.2-78.8 C245.09,872.2,244.48,872.8,243.89,873.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M325.89,786.8c7.6-4.2,14.4-7.4,21.2-9.8C340.09,779.6,333.09,782.6,325.89,786.8 c-22.2,12.8-43.2,32.4-61.6,56.4C281.89,820.4,302.69,801,325.89,786.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M403.29,778.6c-0.4-0.2-1-0.4-1.4-0.6C402.49,778,403.09,778.4,403.29,778.6L403.29,778.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M375.69,771.4c-0.6,0-1.2,0.2-1.8,0.2c0.8,0,1.6-0.2,2.4,0C376.29,771.4,375.89,771.4,375.69,771.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M253.89,858c3-4.4,5.8-9,9-13.2C259.89,848.8,256.89,853.6,253.89,858z"
}), React.createElement("path", {
  className: "st1",
  d: "M362.09,772.8c1-0.2,2.2-0.4,3.2-0.6C364.48,772.6,363.09,772.6,362.09,772.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M348.89,776.4c2.2-0.8,4.2-1.4,6.2-1.8C353.09,775.2,351.29,775.6,348.89,776.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M388.09,772.8c1.6,0.4,3.4,0.8,5,1.4C391.29,773.8,389.89,773.4,388.09,772.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M413.69,775.4c-0.2,0.4-0.8,0.4-1,0.8c16.6,12.6,27.6,34,29.4,64l-231.2,133.4c-0.2,1.8-0.6,3.6-0.8,5.2 c-0.2,2.4-1.6,4.6-3.8,5.8l0,0l239.4-138.2c2.4-1.4,3.8-4,3.6-6.8c-2-34.8-15.8-61.2-38.6-74.2l0,0 C414.29,767.6,415.29,772.2,413.69,775.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M264.69,819.6c2.6-3,5.2-6.2,8-9C270.09,813.4,267.69,816.4,264.69,819.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M278.09,805.6c7.4-7.2,15.2-13.6,23.2-19.6c-0.2,0-0.2,0-0.4,0C293.09,791.8,285.29,798.6,278.09,805.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M218.09,891.4c-1,2.2-2,4.4-3,6.8C216.29,896,216.89,893.8,218.09,891.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M346.29,761.6c1-0.4,2-0.6,3-1C348.09,761.2,347.49,761.4,346.29,761.6L346.29,761.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M250.69,836.4c-1,1.4-2,2.8-3,4.2C248.89,839,249.89,837.6,250.69,836.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M208.09,916.6c-1.6,4.8-3,9.6-4.4,14.4C205.09,926.4,206.49,921.4,208.09,916.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M200.69,942.2c-1.6,6.6-2.6,12.8-3.6,19.2C198.09,955,199.48,948.6,200.69,942.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M229.89,868.6c0.8-1.2,1.4-2.4,2-3.8c-0.2,0.4-0.6,0.8-0.8,1.4C230.29,866.8,230.09,867.6,229.89,868.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M361.49,757.8c-2,0.4-4,0.6-6,1C357.49,758.6,359.48,758.4,361.49,757.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M370.89,764.2c1.8-0.2,3.6-0.2,5.2-0.2C374.48,764,372.69,764.2,370.89,764.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M360.09,765.6c2.2-0.4,4.2-0.8,6.4-1C364.29,765,361.89,765.2,360.09,765.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M350.69,768c1.4-0.4,3-0.8,4.4-1.2C353.69,767.2,351.89,767.6,350.69,768z"
}), React.createElement("path", {
  className: "st0",
  d: "M253.69,845.2c-5.6,7.8-11,15.8-15.8,24.2C242.69,861,248.09,852.8,253.69,845.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M217.49,913c-1,2.8-2.2,5.4-3.2,8.2C215.09,918.6,216.29,916,217.49,913z"
}), React.createElement("path", {
  className: "st0",
  d: "M384.29,764.8c0.6,0,1,0.2,1.6,0.2C385.09,764.8,384.48,764.8,384.29,764.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M234.69,875c-3.6,6.6-7.2,13.4-10.4,20.4C227.69,888.4,231.29,881.4,234.69,875z"
}), React.createElement("path", {
  className: "st0",
  d: "M267.69,827.6c-4.2,4.8-8.4,9.6-12.4,14.8C259.29,837.4,263.69,832.6,267.69,827.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M406.89,771.8c2,1.2,3.6,3,5.6,4.4c0.2-0.4,0.8-0.4,1-0.8c2-3.6,0.6-8-2.8-10c-8.6-5-18.2-7.8-28.4-8.6 C391.29,762.4,399.89,767.6,406.89,771.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M210.09,979c0.2-1.8,0.6-3.6,0.8-5.2l-8.2,4.8l-7-4c0,1.2-0.4,2.4-0.4,3.6c-0.2,2.8,1.2,5.4,3.6,6.8 c1.2,0.8,2.6,1,3.8,1s2.4-0.4,3.6-1C208.09,983.8,209.89,981.4,210.09,979z"
}), React.createElement("path", {
  className: "st0",
  d: "M361.49,757.8c-2,0.4-4,0.6-6,1c-2,0.4-4.2,1.2-6.2,1.8c-1,0.4-2,0.6-3,1c-6,5.4-12.2,10.2-18.4,14 c0.4,0.4,0.6,0.8,1,1.2c7.4-3.8,14.8-6.8,22-9c1.4-0.4,2.8-0.8,4.4-1.2s3.4-0.8,5-1c2-0.4,4.2-0.8,6.4-1c1.6-0.2,3.2-0.2,4.8-0.4 c1.8-0.2,3.4-0.2,5.2-0.2c2.6,0,5.2,0.2,7.8,0.6c0.6,0,1,0,1.6,0.2c7.6,1.2,14.8,3.4,21.4,7c-7.4-4.2-15.8-9.6-24.6-15 C375.69,756.4,368.89,756.6,361.49,757.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M217.49,913c2.2-6,4.4-12,7.2-18c3.2-7,6.8-13.6,10.4-20.4c0.8-1.6,1.6-3.2,2.4-4.8c0.2-0.2,0.2-0.4,0.4-0.6 c4.8-8.4,10.2-16.4,15.8-24.2c0.6-0.8,1.2-1.8,1.8-2.6c3.8-5.2,8.2-10,12.4-14.8c14.4-17,30.4-31.4,47.6-42.6l-3.4-2 c-3.8,1.4-7.2,2.2-10.8,3c-8,6-15.8,12.6-23.2,19.6c-1.6,1.6-3.4,3-5,4.6c-2.8,2.8-5.4,6-8,9c-4.8,5.4-9.6,10.8-14,16.8 c-1,1.4-2,2.8-3,4.2c-5.6,7.8-11,15.8-16,24.4c-0.8,1.2-1.4,2.4-2,3.8c-4.2,7.6-8.2,15.2-11.6,23c-1,2.2-2,4.4-3,6.8 c-2.6,6.2-5,12.4-7,18.4c-1.6,4.8-3.2,9.6-4.4,14.4c-1,3.6-2,7.2-2.8,10.8c-1.4,6.4-2.6,12.8-3.6,19.2c-0.6,4.4-1.4,8.8-1.6,13.2 l7,4c1-18.6,5.2-38,11.6-57.2C215.09,918.6,216.29,916,217.49,913z"
}), React.createElement("path", {
  className: "st0",
  d: "M320.29,779.6c-2.8,1.4-5.6,2.6-8.4,3.8l3.4,2c2.2-1.4,4.4-3.4,6.8-4.6L320.29,779.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M325.69,777.2c-1.8,1-3.6,1.4-5.4,2.4l1.6,1c2.2-1.2,4.4-2.2,6.6-3.4c-0.2-0.4-0.6-0.8-1-1.2 C327.09,776.2,326.49,776.6,325.69,777.2L325.69,777.2z"
}), React.createElement("polygon", {
  className: "st0",
  points: "322.09,780.4 322.09,780.4 320.69,779.6 320.29,779.6  "
}), React.createElement("path", {
  className: "st0",
  d: "M346.89,777.2c0.6-0.2,1.4-0.6,2-0.8C348.29,776.4,347.69,776.8,346.89,777.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M365.29,772.4c2.8-0.4,5.8-0.6,8.4-0.8C371.29,771.6,368.29,771.8,365.29,772.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M355.09,774.4c2.4-0.6,4.6-1.2,6.8-1.6C360.09,773.4,357.69,773.8,355.09,774.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M245.29,871.4c2.8-4.6,5.8-8.8,8.6-13.2C251.29,862.6,248.09,866.6,245.29,871.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M403.69,778.8C403.69,778.6,403.69,778.6,403.69,778.8c17.2,10,28,30.4,30.6,57.6l-222.2,128.2 c-0.4,3.2-1,6.2-1.4,9.4l231.2-133.4c-1.8-30-12.8-51.4-29.4-64C410.29,779,406.89,780.2,403.69,778.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M376.29,771.4c4,0,7.8,0.6,11.6,1.4C384.29,772.2,380.29,771.4,376.29,771.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M263.09,844.8c0.4-0.6,0.8-1,1.2-1.4C263.89,843.8,263.29,844.2,263.09,844.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M393.09,774.2c3,1,6,2,8.8,3.6C398.89,776.4,395.89,775.2,393.09,774.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M213.89,952.2c0.2-0.6,0.2-1.4,0.4-2C213.89,950.6,213.89,951.4,213.89,952.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M384.29,764.8c-2.6-0.4-5.2-0.6-7.8-0.6c-1.8,0-3.4,0-5.2,0.2c-1.6,0-3.2,0.2-4.8,0.4c-2,0.2-4.2,0.6-6.4,1 c-1.6,0.4-3.4,0.6-5,1c-1.4,0.4-2.8,0.8-4.4,1.2c-7.4,2.2-14.6,5.4-22,9c0.4,1,0.8,2,1,3.2c0,2.6-1.2,5-3.4,6.4l0,0 c-1.2,0.8-2.6,1.2-4.2,1.2c-1.2,0-2.6-0.4-3.8-1l-3-1.8c-17.6,11.6-33.4,26-47.8,42.4c-4.2,4.8-8.4,9.6-12.4,14.8 c-0.6,0.8-1.2,1.8-1.8,2.6c-5.6,7.8-11,15.8-15.8,24.2c-1,1.8-2,3.6-3,5.6c-3.6,6.6-7.2,13.4-10.4,20.4c-2.6,6-4.8,12-7.2,18 c-1,2.8-2.2,5.4-3.2,8.2c-6.2,18.8-10.2,38.2-11.6,57.2l8.2-4.8c0.4-3.2,0.8-6.2,1.4-9.4l-0.8,0.4c0.6-4.2,1.6-8.6,2.4-12.8 c0.2-0.6,0.2-1.4,0.4-2c5.4-25.2,15.2-51.6,29.6-76.4c0.4-0.8,1-1.6,1.6-2.4c2.6-4.6,5.8-8.8,8.6-13.2c3-4.4,5.8-9,9-13.2 c0.4-0.6,0.8-1,1.2-1.4c18.4-24,39.4-43.6,61.6-56.4c7.2-4.2,14.2-7.2,21.2-9.8c0.6-0.2,1.4-0.6,2-0.8c2.2-0.8,4.2-1.4,6.2-1.8 c2.4-0.6,4.6-1.2,6.8-1.6c1-0.2,2.2-0.4,3.2-0.6c2.8-0.4,5.8-0.6,8.4-0.8c0.6,0,1.2-0.2,1.8-0.2c0.2,0,0.4,0,0.6,0 c4,0,7.8,0.6,11.6,1.4c1.8,0.4,3.4,0.8,5,1.4c3,1,6,2.2,8.8,3.6c0.4,0.2,1,0.4,1.4,0.6c0,0,0,0,0.2,0.2h0.2c3,1.6,6.8,0.4,9-2.2 c-1.8-1.4-3.4-3.2-5.6-4.4c-7.2-3.8-14.2-6-21.4-7C385.09,764.8,384.48,764.8,384.29,764.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M366.29,764.8c1.6-0.2,3.2-0.2,4.8-0.4C369.48,764.4,368.09,764.4,366.29,764.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M355.09,766.8c1.6-0.4,3.4-0.8,5-1C358.29,766.2,356.49,766.4,355.09,766.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M350.69,768c-7.2,2.2-14.4,5-22,9l0,0C335.89,773.6,343.09,770.2,350.69,768z"
}), React.createElement("path", {
  className: "st0",
  d: "M376.29,764c2.6,0,5.2,0.2,7.8,0.6C381.49,764.2,378.89,764,376.29,764z"
}), React.createElement("path", {
  className: "st0",
  d: "M255.29,842.6c-0.6,0.8-1.2,1.8-1.8,2.6C254.29,844.2,254.69,843.4,255.29,842.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M406.89,771.8c-6.4-3.8-13.6-6-21.4-7C392.69,766,399.89,768.4,406.89,771.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M202.69,978.6c1.4-19,5.4-38.4,11.6-57.2C207.69,940.4,203.69,960,202.69,978.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M224.48,895.2c-2.6,6-4.8,12-7.2,18C219.48,907.2,221.89,901.2,224.48,895.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M267.69,827.6c14.2-16.4,30.2-30.8,47.8-42.4l0,0C298.09,796.2,282.09,810.6,267.69,827.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M234.69,875c1-1.8,1.8-3.8,3-5.6c-0.2,0.2-0.2,0.4-0.4,0.6C236.29,871.4,235.69,873.4,234.69,875z"
}), React.createElement("path", {
  className: "st0",
  d: "M315.29,785.2l3,1.8c1.2,0.6,2.4,1,3.8,1s3-0.4,4.2-1.2l0,0c2.2-1.4,3.4-3.8,3.4-6.4c0-1.2-0.4-2.2-1-3.2 c-2.2,1-4.4,2.2-6.6,3.4C319.89,781.8,317.69,783.8,315.29,785.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M322.09,780.4c-2.4,1.4-4.4,3.2-6.8,4.6l0,0C317.69,783.8,319.89,781.8,322.09,780.4L322.09,780.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M322.09,780.4c2.2-1.2,4.4-2.2,6.6-3.4l0,0C326.49,778,324.48,779,322.09,780.4L322.09,780.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M322.09,780.4L322.09,780.4L322.09,780.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M378.69,606.4c-0.2,0.4-0.8,0.4-1,0.8c9.4,8.4,15.2,22.2,15.2,41.2c0,22.4-7.8,47.4-20.6,69.6 c-3.6,6.4-7.8,12.4-12.4,18.2c2.4,1,4.6,2.2,7,3.4c4.2-5.6,8.2-11.6,11.8-17.8c14-24.2,21.6-50.2,21.6-73.2 c0-24.6-8.6-43-24.4-52.2C379.29,598.4,380.29,602.8,378.69,606.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M322.09,770.6L322.09,770.6c-0.6,0.2-0.8,0.2-1.2,0.6l1.4,0.8c5.6-3,11.2-5.6,16.6-7.8c1-0.4,2-0.8,3-1.2 c1.4-0.6,2.8-1,4.2-1.4c3.6-3.2,7.2-6.6,10.6-10.4c-2.4-1.2-4.6-2.2-6.8-3.2C341.29,757.2,332.09,765,322.09,770.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M278.89,778c-0.2,0.4,0,1-0.2,1.4c-1.4,2.2-3.8,3.6-6.4,3.6c-1.2,0-2.6-0.4-3.8-1c6.6,3.8,14,5.8,22,5.8 c3.2,0,6.8-1,10.2-1.6c2.4-1.8,5-3.4,7.4-5.2l-5-2.8C294.48,780.4,285.89,780.4,278.89,778z"
}), React.createElement("path", {
  className: "st0",
  d: "M355.09,742.2c2.2,1,4.6,2.2,7,3.4c1.6-2,3.4-3.8,4.8-5.8c-2.4-1.2-4.6-2.2-7-3.4 C358.09,738.4,356.49,740.2,355.09,742.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M356.89,751.4c1.6-1.8,3.2-3.8,5-5.8c-2.4-1.2-4.6-2.2-7-3.4c-1.6,2-3.2,4-4.8,5.8 C352.09,748.8,354.48,750.2,356.89,751.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M339.29,764.2c1-0.4,2-0.8,3-1.2C341.29,763.4,340.09,763.8,339.29,764.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M265.69,656.6c-8,13.8-13.6,28.2-17.2,42.2c4-14.4,10-28.8,17.6-42c7.8-13.4,17.4-26,28-36.6 C283.69,630.4,273.89,642.6,265.69,656.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M245.69,712.6c0-0.4,0.2-0.6,0.2-1C245.69,711.8,245.69,712.2,245.69,712.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M303.89,611.4c-0.2,0.2-0.6,0.4-0.8,0.6C303.69,611.6,303.89,611.4,303.89,611.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M371.89,602.6c2,1.2,3.6,3,5.4,4.6c0.2-0.4,0.8-0.4,1-0.8c2-3.6,0.8-8-2.8-10c-6.8-4-14.8-5.6-23.2-5.4 C360.09,595.4,367.09,600,371.89,602.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M349.29,598.4c-16.8,1.2-34,11.4-49.4,26.8c7-6.8,14.4-13,22.2-17.4C331.89,602.4,340.69,599,349.29,598.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M251.49,730c0-9.4,1.6-19.2,4.2-29.2c-5.4,19.2-6.4,37.6-1,52.4c0.2-0.2,0.4-0.2,0.6-0.4 C253.09,746.2,251.49,738.8,251.49,730z"
}), React.createElement("path", {
  className: "st0",
  d: "M351.89,598.4c2.8-0.2,5.6,0,8.2,0.4C357.49,598.4,354.69,598.4,351.89,598.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M268.69,782.2c1.2,0.6,2.4,1,3.8,1c2.4,0,5-1.2,6.4-3.6c0.2-0.4,0-1,0.2-1.4c-2.2-0.8-4.6-1.4-6.6-2.4l-13-7.4 c-1,0.8-2.2,1.4-3.2,2.2C259.48,775.2,263.69,779,268.69,782.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M312.69,775c-3.2,1.4-6.2,2.4-9.4,3.2l5,2.8c2.2-1.6,4.4-3.2,6.8-4.6L312.69,775z"
}), React.createElement("path", {
  className: "st0",
  d: "M261.89,766.4c0.2,0.4,0.6,0.6,1,1c-0.2-0.4-0.4-0.8-0.8-1.2C261.89,766.2,261.89,766.4,261.89,766.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M315.09,776.4c1.2-0.6,2.2-1.6,3.2-2.2l0,0h0.2c0.8-0.4,1.8-1,2.6-1.4c0.4-0.2,0.8-0.4,1.2-0.6l-1.4-0.8 c-2.8,1.6-5.6,2.6-8.2,3.8L315.09,776.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M255.29,752.8c-0.2,0.2-0.4,0.2-0.6,0.4c0.6,1.6,1.4,3.2,2.2,4.6C256.29,756.4,255.89,754.4,255.29,752.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M251.89,763.8c0.2,0.2,0.2,0.4,0.4,0.6l0.2-0.2L251.89,763.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M258.89,761c1,1.8,1.8,3.6,3,5.2l0.2-0.2C260.89,764.4,259.89,762.8,258.89,761z"
}), React.createElement("path", {
  className: "st0",
  d: "M318.69,774c1-0.6,1.8-1,2.8-1.4C320.29,773,319.48,773.6,318.69,774L318.69,774z"
}), React.createElement("path", {
  className: "st0",
  d: "M259.48,768l-7-4l-0.2,0.2c1.2,2.2,2.6,4.2,4,6.2C257.09,769.6,258.09,768.8,259.48,768z"
}), React.createElement("path", {
  className: "st0",
  d: "M318.29,601.4c-5,2.8-9.8,6.2-14.4,10c-0.2,0.2-0.6,0.4-0.8,0.6c-3,2.6-6,5.4-9,8.4 c-10.6,10.8-20.2,23.4-28,36.6c-7.6,13.2-13.6,27.6-17.6,42c-1,4.2-2.2,8.6-2.8,12.6c0,0.4-0.2,0.6-0.2,1c-1,6-1.4,11.8-1.4,17.4 c0,10.4,1.8,19.4,4.8,27.4c2-1.4,3.8-2.8,5.8-4c-5.4-14.8-4.4-33.2,1-52.4c3.6-13.8,9-27.6,16.4-40.4c7.6-13.2,17.2-25.2,27.6-35.2 c15.4-15.4,32.4-25.6,49.4-26.8c1,0,1.8,0,2.8,0c2.8,0,5.6-0.2,8.2,0.4c4.2,0.6,8.2,2,11.8,4c-5-2.8-11.8-7.2-19.4-11.8 C341.89,591.4,330.29,594.4,318.29,601.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M262.69,767.4c-0.2-0.4-0.6-0.6-1-1c-0.8,0.6-1.8,1.2-2.6,1.8l13,7.4C268.89,773.6,265.69,770.6,262.69,767.4z "
}), React.createElement("polygon", {
  className: "st0",
  points: "315.09,776.4 315.09,776.4 312.69,775 312.69,775  "
}), React.createElement("path", {
  className: "st0",
  d: "M258.09,760c-0.4-0.8-0.8-1.4-1.2-2c-0.8-1.6-1.6-3-2.2-4.6c-2,1.4-4,2.6-5.8,4c0.8,2.2,1.6,4.4,2.6,6.4 l0.6,0.4C254.29,762.6,256.29,761.4,258.09,760z"
}), React.createElement("path", {
  className: "st0",
  d: "M258.89,761c-0.2-0.4-0.4-0.6-0.6-1c-2,1.4-4,2.6-5.8,4.2l7,4c0.8-0.6,1.8-1.2,2.6-1.8 C260.69,764.8,259.89,762.6,258.89,761z"
}), React.createElement("path", {
  className: "st0",
  d: "M342.09,762.8c1.4-0.4,2.8-0.8,4-1.2c0,0,0,0,0.2-0.2C345.09,762.2,343.69,762.6,342.09,762.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M308.29,781.2c-2.4,1.6-5,3.4-7.4,5.2c0.2,0,0.2,0,0.4,0C303.69,784.2,305.89,782.6,308.29,781.2L308.29,781.2 z"
}), React.createElement("path", {
  className: "st0",
  d: "M339.29,764.2c-5.4,2.2-11,4.8-16.6,7.8l0,0C327.69,769,333.09,766.4,339.29,764.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M339.29,764.2c-5.8,2.4-11.4,5-16.6,7.8l3.4,2c0.8,0.4,1.2,1.2,1.8,1.8c6.4-3.8,12.6-8.6,18.4-14 c-1.4,0.4-2.8,0.8-4,1.2C341.29,763.4,340.09,763.8,339.29,764.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M301.29,786.2c3.6-0.6,7.2-1.6,10.8-3l-3.6-2.2C305.89,782.6,303.69,784.2,301.29,786.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M315.09,776.4L315.09,776.4c1.2-0.6,2.2-1.6,3.2-2.2h0.2l0,0C317.09,774.8,316.29,775.6,315.09,776.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M308.29,781.2L308.29,781.2c2.4-1.6,4.6-3.2,6.8-4.6l0,0C312.69,777.6,310.69,779.6,308.29,781.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M322.49,771.8L322.49,771.8c-0.4,0.2-0.8,0.4-1.2,0.6C321.49,772.4,321.89,772.2,322.49,771.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M322.49,771.8c-0.4,0.2-0.8,0.4-1.2,0.6c-1,0.6-1.8,1-2.8,1.4h-0.2c-1.2,0.6-2.2,1.6-3.2,2.2l5.4,3 c1.8-0.8,3.6-1.4,5.4-2.4h0.2c0.6-0.4,1.2-0.8,1.8-1.2c-0.6-0.6-1-1.4-1.8-1.8L322.49,771.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M315.09,776.4c-2.4,1.4-4.4,3.2-6.8,4.8l3.6,2.2c2.8-1,5.6-2.4,8.4-3.8L315.09,776.4z"
}), React.createElement("polygon", {
  className: "st0",
  points: "315.09,776.4 315.09,776.4 315.09,776.4  "
}), React.createElement("polygon", {
  className: "st0",
  points: "320.29,779.6 320.69,779.6 315.09,776.4 315.09,776.4  "
}), React.createElement("path", {
  className: "st0",
  d: "M258.89,730c0-4.4,0.4-9.2,1.2-14c-2,12-1.8,23.2,1.2,32.6c0.2,0,0.2-0.2,0.4-0.2 C260.09,742.8,258.89,736.8,258.89,730z"
}), React.createElement("path", {
  className: "st0",
  d: "M350.69,606c-12.2,0.4-25,6.6-37,16.6c4-3.2,8-6,12-8.4C334.69,609,343.09,606.4,350.69,606z"
}), React.createElement("path", {
  className: "st0",
  d: "M305.89,629.6c2-2,4-4,6-5.6C310.09,625.6,308.09,627.6,305.89,629.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M368.69,609.2L368.69,609.2c10.8,6.4,16.6,20.2,16.6,39.2c0,20.6-7,43.8-19.6,65.8c-4,6.8-8.4,13-13,18.8 c2.4,1,4.6,2,7,3c4.4-5.8,8.6-11.8,12.4-18.2c12.8-22.2,20.6-47,20.6-69.6c0-19-5.8-32.8-15.2-41.2 C375.29,610,371.49,611,368.69,609.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M356.29,605.6c0.6,0,1.2,0.2,1.8,0.2C357.49,606,356.89,606,356.29,605.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M260.69,712.6c0.4-2.2,1-4.4,1.6-6.8C261.49,708,261.29,710.2,260.69,712.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M318.29,764c-1.8,1-3.4,1.6-5.2,2.4l7.8,4.4c0.4-0.2,0.8-0.2,1-0.6h0.2c9.8-5.8,19.2-13.6,27.8-22.8 c-2.6-1.2-5-2-7.6-3C335.09,752.6,326.89,759.2,318.29,764L318.29,764z"
}), React.createElement("path", {
  className: "st0",
  d: "M303.29,778l-9.6-5.6c-6.6,0.6-12.6-0.6-17.6-3.4l0,0c3,2,3.8,5.6,2.6,8.8 C285.89,780.4,294.48,780.4,303.29,778z"
}), React.createElement("path", {
  className: "st0",
  d: "M261.49,748.4c-0.2,0-0.2,0.2-0.4,0.2c0.4,1.6,1.2,3.2,1.8,4.6C262.49,751.6,262.09,750.2,261.49,748.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M347.69,739c2.4,0.8,4.6,1.8,7.2,3c1.6-2,3.2-3.8,4.8-5.8c-2.4-1.2-4.6-2.2-7-3 C351.29,735.2,349.48,737.2,347.69,739z"
}), React.createElement("path", {
  className: "st0",
  d: "M268.09,761.6c-0.8-1-1.4-2.2-2-3.4C266.49,759.6,267.09,760.6,268.09,761.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M342.49,745c2.4,0.8,5,1.8,7.6,3c1.8-1.8,3.2-4,4.8-5.8c-2.4-1.2-4.8-2.2-7.2-3 C345.89,741.2,344.48,743,342.49,745z"
}), React.createElement("path", {
  className: "st0",
  d: "M351.89,598.4c-1,0-1.8,0-2.8,0c-8.4,0.8-17.4,3.8-27,9.4c-7.8,4.6-15.2,10.6-22.2,17.4 c-20,20-36.4,48.2-44,75.6c-2.6,9.8-4.2,19.8-4.2,29.2c0,8.8,1.6,16.2,3.8,22.8c2-1.4,4-2.8,6-4.2c-3-9.4-3-20.6-1.2-32.6 c0.2-1.2,0.4-2.4,0.6-3.6c0.4-2.2,1-4.4,1.6-6.8c3.2-13.8,8.6-28,16.6-41.8c7.8-13.4,17.2-25,27.2-34.6c2-2,4-3.8,6-5.6 c0.6-0.4,1.2-1,1.8-1.4c12-10,24.8-16.2,37-16.6c1,0,2-0.4,2.8-0.4c1,0,1.8,0.2,2.6,0.4c0.6,0,1.2,0.2,1.8,0.2 c3.6,0.6,7.2,1.4,10.2,3.2l0.2,0.2c0,0,0,0,0.2,0c3,1.6,6.6,0.4,8.8-2.2c-1.8-1.6-3.4-3.4-5.4-4.6c-3.8-2-7.8-3.2-11.8-4 C357.69,598.4,354.69,598.4,351.89,598.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M293.89,772.6l9.6,5.6c3-0.8,6.2-1.8,9.4-3.2l-8-4.6C300.69,771.4,297.09,772.4,293.89,772.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M276.29,769.2L276.29,769.2c-0.2-0.2-0.2-0.2-0.2-0.2c-3-1.8-5.6-4.4-8-7.2c-2,1.4-4,2.8-6,4.2 c0.2,0.4,0.4,0.8,0.8,1.2c2.6,3.2,5.8,6,9.4,8.4c2,1.2,4.4,1.8,6.6,2.4C280.09,775,279.29,771.4,276.29,769.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M312.69,775c2.8-1.2,5.4-2.2,8.2-3.8l-7.8-4.4c-3,1.4-5.8,2.8-8.6,3.6L312.69,775z"
}), React.createElement("path", {
  className: "st0",
  d: "M258.09,760c2-1.4,4-3,6-4.2c-0.4-0.8-0.8-1.6-1.2-2.4c-0.6-1.6-1.2-3-1.8-4.6c-2,1.4-4,2.8-6,4.2 c0.6,1.6,1,3.6,1.6,5C257.49,758.6,257.69,759.2,258.09,760z"
}), React.createElement("path", {
  className: "st0",
  d: "M262.09,766.2c2-1.4,4-2.8,6-4.2c0,0,0-0.2-0.2-0.2c-0.8-1-1.4-2.2-2-3.4c-0.6-1-1.2-1.8-1.6-2.8 c-2,1.4-4,2.8-6,4.2c0.2,0.4,0.4,0.8,0.6,1C259.89,762.8,260.89,764.4,262.09,766.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M371.89,602.6c-3.6-2-7.6-3.2-11.8-4C364.29,599.6,368.09,600.6,371.89,602.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M299.89,625.2c-10.4,10-20,22-27.6,35.2c-7.4,12.8-13,26.6-16.4,40.4C263.29,673.6,279.89,645.2,299.89,625.2z "
}), React.createElement("path", {
  className: "st0",
  d: "M349.29,598.4c1,0,1.8,0,2.8,0C350.89,598.6,350.09,598.4,349.29,598.4z"
}), React.createElement("polygon", {
  className: "st0",
  points: "312.69,775 312.69,775 304.69,770.2 304.48,770.2  "
}), React.createElement("path", {
  className: "st0",
  d: "M272.09,775.4c-3.8-2.4-6.8-5.2-9.4-8.4C265.69,770.6,268.89,773.6,272.09,775.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M256.89,757.8c0.4,0.8,0.8,1.4,1.2,2l0,0C257.69,759.2,257.49,758.6,256.89,757.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M258.09,760L258.09,760c0.2,0.4,0.4,0.8,0.6,1C258.69,760.6,258.29,760.2,258.09,760z"
}), React.createElement("path", {
  className: "st1",
  d: "M777.89,512.6c1-0.4,2-0.6,3-0.8c2-0.6,4-1.2,6.2-1.8c2.6-0.6,5.2-1,7.8-1.4c1.4-0.2,2.8-0.6,4.4-0.8 c-3.6-2-7.2-4-10.8-5.8C784.69,506,781.49,509.2,777.89,512.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M721.88,538.8c-8,0-15.4-1.8-22.2-5.8l-15.8-9.2c-50.2,40.4-87.2,107.4-93.6,172l37.2,21.4 c0.2-2,0.8-4,1.2-6.2c0.8-5.8,2-11.6,3.4-17.6c1-4,2-7.8,3-11.8c1.4-4.6,2.6-9.2,4.4-14c2.2-6.4,4.6-12.4,7.2-18.6 c1-2.2,1.8-4.4,2.8-6.6c3.6-8.2,7.8-16,12.2-23.8c0.2-0.6,0.4-1,0.8-1.6c0.2-0.4,0.4-0.6,0.6-0.8c5.2-9,11-17.8,17.2-26.2 c0.6-0.8,1.2-1.6,1.8-2.4c5-6.6,10.2-12.6,15.6-18.6c2.2-2.4,4.4-5.2,6.6-7.4c2.4-2.4,5-4.6,7.4-6.8c6.8-6.4,13.6-12.4,20.8-17.6 C728.89,537.6,725.29,538.8,721.88,538.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M626.88,725.4l-44.2-25.6c5-66.8,41.6-136.6,94.4-180l-6.8-3.8c-52.8,44.4-90,114.2-95.2,183.4 c-0.2,2.8,1.2,5.6,3.8,7l50.8,29.4c-2.2-1.4-3.6-4-3.4-6.6C626.68,727.8,626.68,726.6,626.88,725.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M813.69,508c10.2,0.8,19.8,3.6,28.4,8.6c-4.6-2.6-9.6-5.8-15-9c-9.4-5.8-19.4-11.8-29.2-17 c-1.6,2-3.2,3.8-4.8,5.8C800.09,499.8,806.68,504,813.69,508z"
}), React.createElement("path", {
  className: "st0",
  d: "M630.29,736c1.2,0.6,2.4,1,3.8,1C632.69,736.8,631.29,736.4,630.29,736L630.29,736z"
}), React.createElement("path", {
  className: "st0",
  d: "M637.49,736.2C637.49,736.2,637.49,736,637.49,736.2c-1,0.4-2.2,0.8-3.4,0.8 C635.09,736.8,636.29,736.6,637.49,736.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M786.68,509.8c-2,0.4-4.2,1.2-6.2,1.8C782.89,511,784.69,510.4,786.68,509.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M680.09,590.2c-6.2,8.4-11.8,17-17.2,26.2C668.08,607.2,674.09,598.6,680.09,590.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M646.68,649c-2.6,6.2-5,12.4-7.2,18.6C641.68,661.4,643.89,655.2,646.68,649z"
}), React.createElement("path", {
  className: "st0",
  d: "M661.68,618.8c-4.4,7.8-8.4,15.6-12.2,23.8C652.89,634.4,656.88,626.4,661.68,618.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M799.09,508c-1.4,0.2-2.8,0.6-4.4,0.8c6.6-1,12.8-1.2,19-0.8c-6.8-4-13.6-8.2-20.6-11.6c-1.6,2-3.2,4-5,5.8 C791.68,504,795.48,506,799.09,508z"
}), React.createElement("path", {
  className: "st0",
  d: "M635.29,681.6c-1,4-2.2,7.8-3,11.8C632.89,689.6,634.09,685.6,635.29,681.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M697.49,569c-5.4,6-10.6,12.2-15.6,18.6C686.68,581.2,691.88,575.2,697.49,569z"
}), React.createElement("path", {
  className: "st0",
  d: "M627.69,717.4l-37.2-21.4c6.4-64.6,43.2-131.6,93.6-172l-6.8-4c-52.8,43.6-89.4,113.2-94.4,180l44.2,25.6 c0.4-4.8,1.2-9.6,1.8-14.4C628.29,713.4,627.89,715.2,627.69,717.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M704.09,561.6c2.4-2.4,5-4.6,7.4-6.8C708.89,557.2,706.49,559.2,704.09,561.6z"
}), React.createElement("path", {
  className: "st2",
  d: "M679.48,451c3.6-14.4,9.4-29.2,17.4-43.2c8.2-14.2,18.2-26.6,29-37c2.6-2.6,5-4.8,7.8-7.2 c0.6-0.6,1.2-1,1.8-1.6c11.2-9.2,23-16,35.2-19c-12.8-7.4-26.6-15-33.2-15.8c-1.6-0.2-3.2-0.4-5-0.4c-35,0-72,44.2-87,87.8 c-12.4,36-8.6,64.4,10.4,75.8l21.6,12.6c-3.4-11.8-3.4-25.4-1-39.2c0.2-0.8,0.2-1.4,0.4-2.2C677.89,458,678.89,454.4,679.48,451z"
}), React.createElement("path", {
  className: "st0",
  d: "M648.89,503.6l21.6,12.6c2-1.8,4-3.4,6.2-5l-24.2-14c-58.8-35.6,17-185.8,86.4-177.2 c9.6,1.2,28.8,12.4,45,22.2c8.4-0.2,16.2,1.4,23,5.4c-3.4-2-7.6-4.6-12.2-7.4c-23.2-14.2-43.2-26-55-27.4 c-44.4-5.4-89.8,45.2-108,97.4C616.68,453,623.08,488,648.89,503.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M687.49,521.4c-1.2,0.8-2.4,1.6-3.4,2.4l15.8,9.2C695.09,530.2,690.89,526.2,687.49,521.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M683.29,515.2c0-0.2-0.2-0.2-0.2-0.4l-6.6-3.8c-2,1.6-4,3.4-6.2,5l6.8,3.8 C679.09,518,681.29,516.6,683.29,515.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M687.49,521.4c-1.4-2-2.8-4-4-6.2c-2,1.6-4.2,3-6.2,4.6l6.8,4C685.09,522.8,686.29,522.4,687.49,521.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M679.48,451c-1,3.6-1.8,7.2-2.4,10.8C677.89,458,678.89,454.4,679.48,451z"
}), React.createElement("path", {
  className: "st0",
  d: "M675.48,481c0-5.6,0.4-11.2,1.4-17c-2.4,14-2.4,27.4,1,39.2l-21.6-12.6c-19-11.4-22.8-39.8-10.4-75.8 c15.2-43.6,52-87.8,87-87.8c1.6,0,3.4,0,5,0.4c6.6,0.8,20.4,8.2,33.2,15.8c-12.2,2.8-24.2,9.8-35.2,19c4.6-3.6,9.2-6.8,14-9.6 c11.8-6.8,23.4-10,34-10.2c-16.2-9.8-35.4-21-45-22.2c-69.6-8.6-145.2,141.6-86.4,177.2l24.2,14c1.2-1,2.6-1.8,3.8-2.8 C677.49,500.4,675.48,491.2,675.48,481z"
}), React.createElement("path", {
  className: "st0",
  d: "M726.29,370.4c2.6-2.4,5-5,7.8-7.2C731.49,365.6,728.89,368,726.29,370.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M680.48,508.4c-1.2,1-2.6,1.8-3.8,2.8l6.6,3.8C681.88,512.6,681.29,510.4,680.48,508.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M834.48,529.6c-3.2-1.8-6.8-3.2-10.4-4.2c-1.6-0.4-3-1-4.6-1.2c-3.8-0.8-7.8-1.4-12-1.4c-0.6,0-1,0-1.6,0 c-3,0-6.2,0.4-9.4,0.8c-0.8,0.2-1.6,0.2-2.6,0.4c-2.6,0.4-5.2,1.2-7.8,1.8c-1.8,0.6-3.6,1-5.4,1.6c-1.2,0.4-2.4,1-3.6,1.4 c-4.2,1.6-8.6,3.6-13,5.8c-2.2,1.2-4.6,2.2-6.8,3.6c-1.2,0.8-2.4,1.8-3.6,2.6c-26.2,16.8-49.6,40.8-68.2,68.6 c-3,4.4-6,8.8-8.8,13.4c-4.6,7.8-8.8,15.6-12.6,23.8l0,0c-8.2,17.6-14.4,36-18.4,54.6c-0.2,0.8-0.4,1.8-0.6,2.6 c-0.8,4-1.2,8-1.8,12.2l222-128.2C862.89,560,851.88,539.2,834.48,529.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M780.68,527.2c1.8-0.6,3.6-1.2,5.4-1.6C784.28,526.2,782.69,526.4,780.68,527.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M764.09,534.2c4.6-2.2,8.8-4.2,13-5.8C772.89,530.2,768.69,532.2,764.09,534.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M753.69,540.2c-25.2,15.4-48.8,39.4-68.2,68.6C704.09,581.4,727.09,557.4,753.69,540.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M794.09,523.8c0.8-0.2,1.6-0.4,2.6-0.4C795.48,523.6,794.69,523.6,794.09,523.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M807.09,522.6c-0.4,0-0.8,0-1.2,0.2c0.6,0,1,0,1.6,0C807.49,522.6,807.09,522.6,807.09,522.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M642.69,716l0.6-0.4c0.6-4,1-8,1.8-12.2C644.09,707.6,643.08,711.6,642.69,716z"
}), React.createElement("path", {
  className: "st1",
  d: "M675.29,624.8c-4.2,7-7.8,14.2-11.2,21.6c3.8-8.2,8-16,12.6-23.8C676.29,623.4,675.48,623.8,675.29,624.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M819.48,523.8c1.6,0.4,3,0.8,4.6,1.2C822.69,524.8,821.29,524.2,819.48,523.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M645.48,700.6c4-18.6,10.2-36.8,18.4-54.6C655.48,664.2,649.28,682.6,645.48,700.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M844.69,526.4c-0.2,0.4-0.8,0.4-1,0.8c16.6,12.6,27.6,34,29.4,64l-231.2,133.6c-0.2,1.8-0.6,3.4-0.8,5.2 c-0.2,2.6-1.6,4.6-3.8,5.8l0,0l239.4-138.2c2.4-1.4,3.8-4.2,3.6-6.8c-2-34.8-15.8-61.2-38.6-74.4 C845.48,518.6,846.68,523,844.69,526.4z"
}), React.createElement("polygon", {
  className: "st0",
  points: "630.09,736 630.09,736 629.89,735.6  "
}), React.createElement("path", {
  className: "st0",
  d: "M711.49,555c6.8-6.4,13.8-12.2,21-17.6h-0.2C725.09,542.6,718.08,548.4,711.49,555z"
}), React.createElement("path", {
  className: "st0",
  d: "M631.88,693.6c-1.4,6-2.4,11.8-3.4,17.6C629.48,705.2,630.68,699.2,631.88,693.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M697.49,569c2.2-2.4,4.2-5.2,6.6-7.4C701.68,564,699.48,566.6,697.49,569z"
}), React.createElement("path", {
  className: "st0",
  d: "M639.28,667.6c-1.6,4.6-3,9.2-4.4,14C636.49,677.2,637.89,672.4,639.28,667.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M794.48,508.6c-2.6,0.4-5.2,0.8-7.8,1.4C789.28,509.2,791.88,509.2,794.48,508.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M649.28,642.6c-1,2.2-1.8,4.4-2.8,6.6C647.49,646.8,648.29,644.8,649.28,642.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M777.69,512.6c1-0.4,2-0.6,3-1C779.48,511.8,778.89,512.4,777.69,512.6L777.69,512.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M661.68,618.8c0.4-0.8,0.8-1.6,1.4-2.4c-0.2,0.4-0.4,0.6-0.6,0.8C661.88,617.6,661.68,618.4,661.68,618.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M681.68,587.6c-0.6,0.8-1.2,1.6-1.8,2.4C680.48,589.6,681.29,588.6,681.68,587.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M790.48,516.8c2.6-0.6,5-1,7.6-1.2C795.48,516,792.89,516.4,790.48,516.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M801.68,515.2c2.2-0.2,4.2-0.2,6.4-0.2C805.68,515.2,803.89,515.2,801.68,515.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M772.89,522.2c0.4-0.2,1-0.4,1.4-0.6C774.09,521.6,773.69,521.8,772.89,522.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M641.29,730.2c0.2-1.8,0.6-3.4,0.8-5.2l-8.2,4.8l-7-4c0,1.2-0.4,2.4-0.4,3.6c-0.2,2.6,1.2,5.2,3.4,6.6l0.2,0.2 c1.2,0.6,2.4,1,3.8,1c1.2,0,2.4-0.4,3.6-1C639.48,734.8,640.89,732.6,641.29,730.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M780.89,519.2c2-0.6,3.8-1.2,5.8-1.6C785.09,518,782.89,518.8,780.89,519.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M814.69,515.6c0.8,0,1.6,0.2,2.4,0.2C816.49,515.6,815.48,515.6,814.69,515.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M838.29,522.8c2,1.2,3.6,3,5.6,4.4c0.2-0.4,0.8-0.4,1-0.8c2-3.6,0.6-8-2.8-10c-8.6-5-18.2-7.8-28.4-8.6 C822.49,513.4,830.89,518.8,838.29,522.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M684.69,596.4c-5.6,7.8-11,15.8-15.8,24.2C673.89,612.2,679.09,604,684.69,596.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M648.89,663.8c-1,2.8-2.4,5.6-3.4,8.6C646.68,669.6,647.89,666.4,648.89,663.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M666.88,624c-4,7.2-8,14.6-11.4,22C659.09,638.8,662.89,631.4,666.88,624z"
}), React.createElement("path", {
  className: "st0",
  d: "M699.09,578.8c-4.2,4.8-8.4,9.6-12.2,14.8C690.48,588.4,694.69,583.6,699.09,578.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M794.48,508.6c-2.6,0.4-5.2,0.8-7.8,1.4c-2,0.4-4,1.2-6.2,1.8c-1,0.4-2,0.6-3,1c-6,5.4-12.2,10.2-18.6,14.2 c0.4,0.4,0.6,0.8,1,1.2c4.4-2.2,8.8-4.2,13-6c0.4-0.2,1-0.4,1.4-0.6c2.2-0.8,4.4-1.6,6.6-2.2c2-0.6,3.8-1.2,5.8-1.6 c1.2-0.4,2.4-0.6,3.8-0.8c2.6-0.6,5-1,7.6-1.2c1.2-0.2,2.4-0.2,3.4-0.2c2.2-0.2,4.2-0.2,6.4-0.2c2.4,0,4.6,0.2,6.8,0.4 c0.8,0.2,1.6,0.2,2.4,0.2c7.6,1.2,14.6,3.4,21,7c-7.4-4.2-15.8-9.6-24.8-15C807.69,507.4,801.29,507.8,794.48,508.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M648.89,663.8c2.2-5.8,4.2-11.6,6.8-17.4c3.4-7.6,7.2-14.8,11.4-22c0.6-1,1-2.2,1.6-3.2c0-0.2,0.2-0.2,0.2-0.4 c4.8-8.4,10.2-16.4,15.8-24.2c0.6-1,1.2-2,2-2.8c3.8-5.2,8-10,12.2-14.8c14.4-17,30.6-31.4,47.8-42.6l-3.4-2c-3.8,1.4-7.4,2.2-11,3 c-7.2,5.4-14.2,11.4-21,17.6c-2.4,2.4-5,4.4-7.4,6.8s-4.4,5-6.6,7.4c-5.4,6-10.6,12-15.6,18.6c-0.6,0.8-1.2,1.6-1.8,2.4 c-6,8.2-11.8,17-17.2,26.2c-0.4,0.8-0.8,1.6-1.4,2.4c-4.4,7.8-8.4,15.8-12.2,23.8c-1,2.2-2,4.4-2.8,6.6c-2.6,6.2-5,12.4-7.2,18.6 c-1.6,4.6-3,9.2-4.4,14c-1.2,4-2.2,7.8-3,11.8c-1.4,5.8-2.4,11.8-3.4,17.6c-0.8,4.8-1.4,9.6-1.8,14.4l7,4c1-18.6,5.2-38,11.6-57.2 C646.68,669.6,647.89,666.4,648.89,663.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M751.68,530.4c-2.8,1.4-5.6,2.6-8.4,3.8l3.4,2c2.2-1.4,4.4-3.4,6.8-4.6L751.68,530.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M757.09,528c-1.8,1-3.6,1.4-5.4,2.4l1.6,1l0,0c2.2-1.2,4.4-2.2,6.6-3.4c-0.2-0.4-0.6-0.8-1-1.2 C758.29,527.2,757.89,527.6,757.09,528L757.09,528z"
}), React.createElement("polygon", {
  className: "st0",
  points: "753.29,531.4 753.69,531.4 751.88,530.4 751.68,530.4  "
}), React.createElement("path", {
  className: "st0",
  d: "M664.09,646.4L664.09,646.4L664.09,646.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M676.68,622.6c2.8-4.6,5.8-9,8.8-13.4C682.49,613.6,679.28,617.8,676.68,622.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M796.49,523.4c3.2-0.4,6.4-0.8,9.4-0.8C802.89,522.6,799.48,522.6,796.49,523.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M645.09,703.4c0.2-0.8,0.4-1.8,0.6-2.6C645.48,701.6,645.29,702.6,645.09,703.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M777.09,528.6c1.2-0.4,2.4-1,3.6-1.4C779.48,527.6,778.29,528,777.09,528.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M807.69,522.6c4.2,0,8.2,0.6,12,1.4C815.48,523,811.68,522.6,807.69,522.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M764.09,534.2c-2.2,1.2-4.4,2.2-6.8,3.4c-1.2,0.8-2.4,1.8-3.6,2.6c1.2-0.8,2.4-1.8,3.6-2.6 C759.48,536.4,761.68,535.4,764.09,534.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M835.09,529.6c-3.6-1.8-7.2-3.2-10.8-4.4c3.6,1.2,7.2,2.4,10.4,4.2c17.4,10,28.2,30.4,30.8,57.8l-222,128.2 c-0.4,3.2-1,6.2-1.4,9.4l231.2-133.6c-1.8-30-12.8-51.4-29.4-64C841.68,530.2,837.89,531.4,835.09,529.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M786.29,525.4c2.6-0.8,5.2-1.4,7.8-1.8C791.49,524.2,788.89,525,786.29,525.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M814.69,515.6c-2.2-0.2-4.6-0.4-6.8-0.4c-2,0-4.2,0-6.4,0.2c-1.2,0-2.4,0.2-3.4,0.2c-2.4,0.2-5,0.8-7.6,1.2 c-1.2,0.2-2.4,0.4-3.8,0.8c-2,0.4-3.8,1-5.8,1.6c-2.2,0.6-4.4,1.4-6.6,2.2c-0.4,0.2-1,0.4-1.4,0.6c-4.4,1.8-8.8,3.8-13,6 c0.4,1,0.8,2,1,3c0,2.6-1.2,5-3.2,6.4l0,0c-1.2,0.8-2.8,1.2-4.2,1.2s-2.6-0.4-3.8-1l-3-1.8c-17.6,11.6-33.6,26-47.8,42.6 c-4.2,4.8-8.4,9.6-12.2,14.8c-0.6,1-1.2,2-2,2.8c-5.6,7.8-11,15.8-15.8,24.2c-0.6,1.2-1.2,2.4-2,3.6c-4,7.2-8,14.6-11.4,22 c-2.6,5.8-4.8,11.6-6.8,17.4c-1,2.8-2.4,5.8-3.4,8.6c-6.2,18.8-10.2,38.2-11.6,57.2l8.2-4.8c0.4-3.2,0.8-6.2,1.4-9.4l-0.6,0.4 c0.6-4.2,1.6-8.4,2.4-12.6c0.2-0.8,0.4-1.8,0.6-2.6c3.8-18,9.8-36.4,18.4-54.6l0,0c3.4-7.2,7.2-14.4,11.2-21.6 c0.4-0.8,1-1.4,1.4-2.2c2.8-4.6,5.8-9,8.8-13.4c19.6-29.4,43-53.2,68.2-68.6c1.2-0.8,2.4-1.8,3.6-2.6c2.4-1.2,4.6-2.4,6.8-3.4 c4.4-2.2,8.8-4.2,13-5.8c1.2-0.4,2.4-1,3.6-1.4c1.8-0.6,3.6-1.2,5.4-1.6c2.6-0.8,5.2-1.4,7.8-1.8c0.8-0.2,1.6-0.4,2.6-0.4 c3.2-0.4,6.4-0.8,9.4-0.8c0.4,0,0.8-0.2,1.2-0.2c0.2,0,0.2,0,0.4,0c4.2,0,8.2,0.6,12,1.4c1.6,0.4,3,0.8,4.6,1.2 c3.6,1.2,7.2,2.6,10.8,4.4c3,1.6,6.8,0.6,9-2.2c-1.8-1.4-3.4-3.2-5.6-4.4c-7-3.8-14-6-21-7C816.49,515.6,815.48,515.6,814.69,515.6 z"
}), React.createElement("path", {
  className: "st0",
  d: "M838.29,522.8c-6.4-3.8-13.6-6-21-7C824.09,517.2,831.29,519.2,838.29,522.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M807.89,515.2c2.2,0,4.6,0.2,6.8,0.4C812.69,515.2,810.29,515.2,807.89,515.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M686.68,593.4c-0.6,1-1.2,2-2,2.8C685.48,595.2,685.89,594.2,686.68,593.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M772.89,522.2c-4.4,1.6-8.6,3.6-13,6l0,0C764.28,526,768.89,523.8,772.89,522.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M633.89,729.6c1.4-19,5.4-38.4,11.6-57.2C639.09,691.4,635.09,711,633.89,729.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M774.48,521.4c2.2-0.8,4.4-1.4,6.6-2.2C779.09,520,776.68,520.6,774.48,521.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M655.68,646.4c-2.6,5.8-4.8,11.6-6.8,17.4C650.89,657.8,653.08,651.8,655.68,646.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M699.09,578.8c14.2-16.4,30.2-30.8,47.8-42.6l0,0C729.48,547.2,713.69,561.6,699.09,578.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M786.68,517.6c1.2-0.4,2.4-0.6,3.8-0.8C789.28,517.2,788.08,517.4,786.68,517.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M798.08,515.6c1.2-0.2,2.4-0.2,3.4-0.2C800.48,515.4,799.09,515.4,798.08,515.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M666.88,624c0.6-1.2,1.2-2.4,2-3.6c0,0.2-0.2,0.2-0.2,0.4C668.08,621.8,667.69,623,666.88,624z"
}), React.createElement("path", {
  className: "st0",
  d: "M746.68,536.2l3,1.8c1.2,0.6,2.4,1,3.8,1s2.8-0.4,4.2-1.2l0,0c2.2-1.4,3.4-3.8,3.2-6.4c0-1-0.4-2.2-1-3 c-2.2,1.2-4.4,2.2-6.6,3.4S749.09,534.8,746.68,536.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M760.09,528L760.09,528c-2.2,1-4.4,2.2-6.6,3.4C755.48,530.2,757.89,529,760.09,528z"
}), React.createElement("path", {
  className: "st0",
  d: "M746.68,536.2L746.68,536.2c2.4-1.4,4.4-3.2,6.8-4.6C751.29,532.6,749.09,534.8,746.68,536.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M810.09,357.4c-0.2,0.4-0.8,0.6-1.2,0.8c9.4,8.4,15.2,22.2,15.2,41.2c0,22.6-8,47.6-20.6,69.6l0,0 c-3.6,6.4-7.8,12.4-12.2,18.2c2.4,1,4.6,2.2,7,3.4c4.2-5.6,8.2-11.6,11.8-17.8c14-24.2,21.6-50.2,21.6-73.2c0-24.4-8.6-43-24.4-52 h-0.2c0,0,0,0,0.2,0C810.48,349.2,811.68,353.6,810.09,357.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M710.29,529c-0.2,0.4,0,1-0.2,1.4c-1.4,2.2-3.8,3.6-6.4,3.6c-1.2,0-2.6-0.4-3.8-1c6.6,3.8,14.2,5.8,22.2,5.8 c3.2,0,6.8-1,10.2-1.6c2.4-1.8,5-3.4,7.4-5.2l-4.8-2.8C725.48,531.4,717.49,531.4,710.29,529z"
}), React.createElement("path", {
  className: "st0",
  d: "M753.69,521.4L753.69,521.4c-0.4,0.2-0.8,0.4-1.2,0.6l1.4,0.8c5.8-3,11.4-5.6,17-7.8c1-0.4,1.8-0.8,2.8-1.2 c1.4-0.6,2.8-1,4.2-1.4c3.6-3.2,7.2-6.6,10.4-10.4c-2.4-1.2-4.6-2.2-6.8-3.2C772.89,508,763.29,516,753.69,521.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M786.29,493c2.2,1,4.6,2.2,7,3.4c1.6-2,3.4-3.8,4.8-5.8c-2.4-1.2-4.6-2.2-7-3.4 C789.28,489.2,787.89,491,786.29,493z"
}), React.createElement("path", {
  className: "st0",
  d: "M770.48,515.2c1-0.4,1.8-0.8,2.8-1.2C772.69,514.2,771.68,514.8,770.48,515.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M788.08,502.2c1.6-1.8,3.2-3.8,5-5.8c-2.4-1.2-4.6-2.2-7-3.4c-1.6,2-3.2,4-4.8,5.8 C783.69,499.8,785.68,501,788.08,502.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M697.09,407.8c-8.2,14.2-13.8,28.8-17.4,43.2c4-14.8,10.2-29.6,18-43c7.8-13.6,17.6-26.4,28.6-37.4 C715.48,381,705.48,393.4,697.09,407.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M676.68,464c0.2-0.8,0.2-1.4,0.4-2.2C677.09,462.4,676.88,463,676.68,464z"
}), React.createElement("path", {
  className: "st0",
  d: "M735.68,361.8c-0.6,0.6-1.2,1-1.8,1.6C734.48,363,735.29,362.4,735.68,361.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M803.29,353.6c2,1.2,3.6,3,5.4,4.4c0.4-0.4,0.8-0.4,1.2-0.8c1.8-3.6,0.6-8-2.8-10c0,0,0,0-0.2,0 c-6.8-4-14.8-5.4-23-5.4C791.49,346.6,798.29,351,803.29,353.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M784.09,349.2c2.6,0,5,0,7.4,0.4C789.09,349.2,786.49,349.6,784.09,349.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M682.89,481c0-9.4,1.6-19,4.2-28.8c-5.2,19-6.2,37.4-1,52.2c0.2-0.2,0.4-0.2,0.6-0.4 C684.28,497.2,682.89,489.8,682.89,481z"
}), React.createElement("path", {
  className: "st0",
  d: "M780.48,349.2c-16.8,1.2-33.8,11.4-49,26.6c7-6.8,14.4-12.8,22.2-17.4C762.89,353.4,771.88,350.4,780.48,349.2 z"
}), React.createElement("path", {
  className: "st0",
  d: "M699.89,532.8c1.2,0.6,2.4,1,3.8,1c2.6,0,5-1.4,6.4-3.6c0.2-0.4,0-1,0.2-1.4c-2.2-0.8-4.6-1.4-6.6-2.4l-13-7.4 c-1,0.8-2.2,1.4-3.2,2.2C690.89,526.2,695.09,530.2,699.89,532.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M693.08,517.4c0.2,0.4,0.6,0.6,1,1c-0.2-0.4-0.4-0.8-0.8-1.2C693.29,517.2,693.29,517.4,693.08,517.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M744.09,526c-3.2,1.4-6.2,2.4-9.4,3.2l4.8,2.8c1.8-1.2,3.6-2.6,5.4-3.8c0.4-0.2,0.8-0.6,1.2-0.8L744.09,526z"
}), React.createElement("path", {
  className: "st0",
  d: "M746.49,527.4c1-0.6,2-1.6,3.2-2.2h0.2c1.4-0.8,2.6-1.4,4-2l-1.4-0.8c-2.8,1.6-5.6,2.6-8.2,3.8L746.49,527.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M686.68,503.6c-0.2,0.2-0.4,0.2-0.6,0.4c0.6,1.6,1.4,3.2,2.2,4.8C687.69,507.4,687.09,505.4,686.68,503.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M682.89,514.8c0,0.2,0.2,0.2,0.2,0.4c0,0,0.2,0,0.2-0.2L682.89,514.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M745.29,528.4c0.4-0.2,0.8-0.6,1.2-0.8l0,0C745.89,527.6,745.48,527.8,745.29,528.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M690.09,511.6c1,1.8,2,4,3.2,5.6l0.2-0.2C692.09,515.4,690.89,513.8,690.09,511.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M746.49,527.4L746.49,527.4c1.2-0.6,2.2-1.6,3.4-2.2l0,0c0,0,0,0-0.2,0 C748.69,525.6,747.69,526.4,746.49,527.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M690.48,519l-7-4c0,0-0.2,0-0.2,0.2c1.2,2.2,2.6,4.2,4,6.2C688.29,520.4,689.48,520,690.48,519z"
}), React.createElement("path", {
  className: "st0",
  d: "M749.89,352.4c-4.8,2.8-9.4,6-14,9.6c-0.6,0.6-1.2,1-1.8,1.6c-2.6,2.2-5.2,4.6-7.8,7.2 c-11,10.8-20.8,23.8-28.6,37.4c-7.8,13.4-14,28.2-18,43c-1,3.6-1.8,7.2-2.4,10.8c-0.2,0.8-0.2,1.4-0.4,2.2 c-0.8,5.8-1.4,11.6-1.4,17c0,10.4,1.8,19.4,4.8,27.4c2-1.4,3.8-2.8,5.8-4c-5.4-14.6-4.4-33,1-52.2c3.6-13.8,9-27.8,16.6-40.6 c7.6-13.2,17.2-25.2,27.6-35.4c15.2-15.2,32.4-25.4,49-26.6c1.2-0.2,2.4,0,3.6,0c2.4,0,5,0,7.4,0.4c4.2,0.6,8.4,2,12,4 c-5-2.8-12-7.2-19.4-11.8C773.08,342.2,761.68,345.4,749.89,352.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M694.09,518.4c-0.2-0.4-0.6-0.6-1-1c-0.8,0.6-1.8,1.2-2.6,1.8l13,7.4C700.09,524.4,696.88,521.4,694.09,518.4z "
}), React.createElement("polygon", {
  className: "st0",
  points: "746.49,527.4 746.49,527.4 744.09,526 744.09,526  "
}), React.createElement("path", {
  className: "st0",
  d: "M689.28,511c-0.4-0.6-0.8-1.2-1.2-2c-0.8-1.6-1.6-3-2.2-4.8c-2,1.4-4,2.6-5.8,4c0.8,2.2,1.6,4.4,2.8,6.4 l0.6,0.6C685.48,513.6,687.49,512.4,689.28,511z"
}), React.createElement("path", {
  className: "st0",
  d: "M746.49,527.4L746.49,527.4L746.49,527.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M690.09,511.6c-0.2-0.2-0.4-0.6-0.6-0.8c-2,1.4-4,2.6-5.8,4.2l7,4c0.8-0.6,1.8-1.2,2.6-1.8 C691.68,515.4,690.89,513.6,690.09,511.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M773.29,513.8c1.4-0.4,2.8-0.8,4.2-1.2c0,0,0,0,0.2-0.2C776.49,512.8,775.09,513.6,773.29,513.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M770.48,515.2c-5.6,2.2-11.2,4.8-17,7.8l0,0C759.09,520.2,764.69,517.6,770.48,515.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M739.48,531.8c-2.6,1.6-5,3.4-7.4,5.2h0.2C734.69,535.2,737.09,533.8,739.48,531.8L739.48,531.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M770.48,515.2c-6,2.4-11.6,5-16.8,7.8l3.4,2c0.8,0.4,1.2,1.2,1.8,1.8c6.4-3.8,12.6-8.8,18.6-14.2 c-1.4,0.4-2.8,0.8-4.2,1.2C772.69,514.2,771.68,514.8,770.48,515.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M732.49,537.2c3.6-0.6,7.2-1.6,11-3l-3.8-2.2C737.09,533.8,734.69,535.2,732.49,537.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M739.48,532.2c1.8-1.2,3.6-2.6,5.4-3.8C743.08,529.2,741.49,530.6,739.48,532.2L739.48,532.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M750.09,525c1.2-0.6,2.6-1.4,3.8-2l0,0C752.49,523.8,751.29,524.2,750.09,525 C749.89,525,749.89,525,750.09,525z"
}), React.createElement("path", {
  className: "st0",
  d: "M753.89,522.8c-1.2,0.6-2.6,1.4-3.8,2h-0.2l0,0c-1.2,0.6-2.2,1.6-3.4,2.2l5.4,3.2c1.8-0.8,3.6-1.4,5.4-2.4l0,0 c0.6-0.4,1.2-0.8,1.8-1.2c-0.6-0.6-1-1.4-1.8-1.8L753.89,522.8z"
}), React.createElement("path", {
  className: "st0",
  d: "M746.49,527.4c-0.4,0.2-0.8,0.6-1.2,0.8c-1.8,1.2-3.6,2.6-5.4,3.8l3.8,2.2c2.8-1,5.6-2.4,8.4-3.8L746.49,527.4 z"
}), React.createElement("polygon", {
  className: "st0",
  points: "751.68,530.4 751.88,530.4 746.49,527.4 746.49,527.4  "
}), React.createElement("path", {
  className: "st0",
  d: "M800.09,360.4C800.09,360.4,799.89,360.4,800.09,360.4c10.8,6.4,16.6,20.2,16.6,39c0,20.6-7,44-19.6,65.8 c-4,6.8-8.4,13-13,18.8c2.4,1,4.6,2,7,3.2c4.4-5.8,8.6-11.8,12.2-18.2l0,0c12.8-22,20.6-47,20.6-69.6c0-19-5.8-32.8-15.2-41.2 C806.68,361,802.89,361.8,800.09,360.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M771.29,359c-8.4,2.6-16.8,7.4-25,13.8c3.6-2.8,7.2-5.4,11-7.6C761.88,362.4,766.68,360.4,771.29,359z"
}), React.createElement("path", {
  className: "st0",
  d: "M691.88,463c0.4-2,0.8-3.8,1.4-5.8C692.89,459.2,692.49,461,691.88,463z"
}), React.createElement("path", {
  className: "st0",
  d: "M787.69,356.6c0.6,0,1.2,0.2,1.8,0.2C788.89,356.8,788.08,356.8,787.69,356.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M690.48,481c0-4.2,0.4-8.8,1-13.2c-1.8,11.6-1.6,22.6,1.2,32c0.2,0,0.2-0.2,0.4-0.2 C691.49,494,690.48,488,690.48,481z"
}), React.createElement("path", {
  className: "st0",
  d: "M738.69,379.2c1.4-1.2,2.6-2.6,4-3.8C741.29,376.6,739.89,378,738.69,379.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M771.88,358.6c3.4-1,6.8-1.4,10-1.6C778.89,357.2,775.48,357.8,771.88,358.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M750.29,515.2c-0.2,0-0.2,0.2-0.4,0.2c-1.8,1-3.4,1.6-5.2,2.4l7.8,4.4c0.4-0.2,0.8-0.2,1-0.6l0,0 c9.8-5.8,19.2-13.6,27.8-22.6c-2.6-1.2-5-2-7.4-3C766.49,503.6,758.29,510.4,750.29,515.2L750.29,515.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M734.69,529l-9.6-5.6c-6.6,0.6-12.6-0.4-17.6-3.4c0,0,0,0.2,0.2,0.2c3,1.8,3.8,5.6,2.6,8.8 C717.49,531.4,725.48,531.4,734.69,529z"
}), React.createElement("path", {
  className: "st0",
  d: "M692.89,499.2c-0.2,0-0.2,0.2-0.4,0.2c0.4,1.6,1,3,1.8,4.6C693.89,502.8,693.29,501,692.89,499.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M779.09,490c2.4,0.8,4.6,1.8,7.2,3c1.6-2,3.2-3.8,4.8-5.8c-2.4-1.2-4.6-2.2-7-3.2 C782.49,486,780.68,488,779.09,490z"
}), React.createElement("path", {
  className: "st0",
  d: "M699.09,512.6c-0.8-1-1.4-2.2-2-3.2C697.89,510.4,698.29,511.6,699.09,512.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M773.89,496c2.4,0.8,5,1.8,7.4,3c1.8-1.8,3.2-4,4.8-5.8c-2.4-1.2-4.8-2-7.2-3 C777.49,492.2,775.48,494.2,773.89,496z"
}), React.createElement("path", {
  className: "st0",
  d: "M784.09,349.2c-1.2,0-2.4-0.2-3.6,0c-8.2,0.8-17.4,3.8-26.8,9.4c-7.8,4.6-15.2,10.6-22.2,17.4 c-20.2,20.2-36.6,48.4-44.2,76c-2.6,9.8-4.2,19.6-4.2,28.8c0,8.8,1.6,16.2,3.8,22.8c2-1.4,4-2.8,6-4.2c-2.8-9.2-3-20.2-1.2-32 c0.2-1.6,0.4-3,0.6-4.6c0.4-2,0.8-3.8,1.4-5.8c3.2-14,8.6-28.4,16.6-42.2c8-14,17.8-26,28.4-35.6c1.4-1.2,2.8-2.6,4-3.8 c1.2-1,2.4-2,3.8-3c8.2-6.6,16.6-11.2,25-13.8c0.2,0,0.6-0.2,0.8-0.2c3.4-1,6.6-1.4,10-1.6c1,0,2-0.4,3-0.4c1,0,1.8,0.2,2.8,0.4 c0.6,0,1.2,0.2,1.8,0.2c3.6,0.6,7.2,1.4,10.2,3.2l0.2,0.2l0,0c3,1.6,6.6,0.4,8.8-2.2c-1.8-1.6-3.4-3.4-5.4-4.4c-3.8-2-7.8-3.2-12-4 C789.09,349.2,786.68,349.2,784.09,349.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M744.09,526c2.8-1.2,5.4-2.2,8.2-3.8l-7.8-4.4c-2.8,1.4-5.8,2.8-8.6,3.6L744.09,526z"
}), React.createElement("path", {
  className: "st0",
  d: "M707.69,520.2C707.69,520.2,707.49,520.2,707.69,520.2C707.49,520.2,707.49,520.2,707.69,520.2 c-3.2-2-5.8-4.4-8.2-7.4c-2,1.4-4,2.8-6,4.2c0.2,0.4,0.4,0.8,0.8,1.2c2.6,3.2,5.8,6,9.4,8.4c2,1.2,4.4,1.8,6.6,2.4 C711.49,526,710.48,522.2,707.69,520.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M725.09,523.6l9.6,5.6c3-0.8,6.2-1.8,9.4-3.2l-8.2-4.6C732.09,522.6,728.69,523.4,725.09,523.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M689.28,511c2-1.4,4-3,6-4.2c-0.4-0.8-0.8-1.6-1.2-2.4c-0.6-1.4-1.2-3-1.8-4.6c-2,1.4-4,2.8-6,4.2 c0.6,1.6,1,3.6,1.6,5.2C688.69,509.6,689.09,510,689.28,511z"
}), React.createElement("path", {
  className: "st0",
  d: "M693.29,517.2c2-1.4,4-2.8,6-4.2c0,0,0-0.2-0.2-0.2c-0.8-1-1.2-2.2-2-3.2c-0.6-1-1.2-1.8-1.8-3 c-2,1.4-4,2.8-6,4.2c0.2,0.2,0.4,0.6,0.4,0.8C690.89,513.8,692.09,515.4,693.29,517.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M803.29,353.6c-3.6-2-7.6-3.4-12-4C795.48,350.4,799.28,351.6,803.29,353.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M780.48,349.2c1.2,0,2.4,0,3.6,0C782.89,349.6,781.68,349.2,780.48,349.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M731.29,376c-10.6,10.2-20,22-27.6,35.4c-7.4,13-13,26.8-16.6,40.6C694.48,424.4,711.29,396,731.29,376z"
}), React.createElement("polygon", {
  className: "st0",
  points: "744.09,526 744.09,526 735.89,521.4 735.89,521.4  "
}), React.createElement("path", {
  className: "st0",
  d: "M703.69,526.4c-3.6-2.4-6.8-5.2-9.4-8.4C696.88,521.4,700.09,524.4,703.69,526.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M688.29,509c0.4,0.8,0.8,1.4,1.2,2l0,0C689.09,510,688.69,509.6,688.29,509z"
}), React.createElement("path", {
  className: "st0",
  d: "M689.28,511L689.28,511c0.2,0.4,0.4,0.6,0.4,0.8C689.89,511.6,689.48,511,689.28,511z"
}));

var SvgWorkshopIcon = function SvgWorkshopIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWorkshopIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Workshop_Icon.3d104a16.svg";
export { ForwardRef as ReactComponent };